[
  {
    "key": "txtPillars",
    "text": "Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Pillars"
      }
    ]
  },
  {
    "key": "YIELD",
    "text": "Yield",
    "translations": [
      {
        "language": "AR",
        "text": "العائد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Yield"
      }
    ]
  },
  {
    "key": "DIRECTION",
    "text": "Direction",
    "translations": [
      {
        "language": "AR",
        "text": "التوجيه"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Direction"
      }
    ]
  },
  {
    "key": "ASSURANCE",
    "text": "Assurance",
    "translations": [
      {
        "language": "AR",
        "text": "الثقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Assurance"
      }
    ]
  },
  {
    "key": "ENABLEMENT",
    "text": "Enablement",
    "translations": [
      {
        "language": "AR",
        "text": "التمكين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Enablement"
      }
    ]
  },
  {
    "key": "RECEPTIVENESS",
    "text": "Receptiveness",
    "translations": [
      {
        "language": "AR",
        "text": "التقبل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Receptiveness"
      }
    ]
  },
  {
    "key": "txtOverallAiReadiness",
    "text": "Overall AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي الكلية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall AI Readiness"
      }
    ]
  },
  {
    "key": "txt_DateClose_751",
    "text": "Date Closed",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإغلاق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Date Closed"
      }
    ]
  },
  {
    "key": "txt_Responden_295",
    "text": "Respondent updated successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث المستجيبين بنجاح"
      },
      {
        "language": "EN",
        "text": "Respondent updated successfully!"
      }
    ]
  },
  {
    "key": "txt_select_respondents",
    "text": "Select Respondents to send reminders",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المستجيبين لإرسال التذكيرات"
      },
      {
        "language": "EN",
        "text": "Select Respondents to send reminders"
      }
    ]
  },
  {
    "key": "JOD",
    "text": "Joining date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      },
      {
        "language": "EN",
        "text": "Joining date"
      }
    ]
  },
  {
    "key": "DOB",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      },
      {
        "language": "EN",
        "text": "Date of Birth"
      }
    ]
  },
  {
    "key": "txt_Workplace_591",
    "text": "AI Readiness By",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي مكان العمل حسب"
      },
      {
        "language": "EN",
        "text": "AI Readiness By"
      }
    ]
  },
  {
    "key": "txt_export_tb",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Download"
      }
    ]
  },
  {
    "key": "txt_Customize_416",
    "text": "Customize the invitation email template or use the default template generated by Zenithr.<br> Hint: Do not erase the survey link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. <br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على <b>\"النموذج الأساسي\"</b>."
      },
      {
        "language": "EN",
        "text": "Customize the invitation email template or use the default template generated by Zenithr.<br> Hint: Do not erase the survey link. If erased, click on the default button."
      }
    ]
  },
  {
    "key": "txt_Youcanexp_908",
    "text": "You can export the comparison charts as per the current view. </br> Note: Available in PDF format",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل الرسوم البيانية للمقارنة وفقًا للعرض الحالي.</br> ملحوظة: متوفر في صيغة PDF. "
      },
      {
        "language": "EN",
        "text": "You can export the comparison charts as per the current view. </br> Note: Available in PDF format"
      }
    ]
  },
  {
    "key": "txt_Selectthe_788",
    "text": "Select the companies (if any) you want to compare. </br>Hint: if you have multiple surveys, you have the option to view average scores or select surveys for a tailored analysis! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الشركات (إن وُجد) التي ترغب في مقارنتها. </br>تلميح: إذا كانت لديك استبيانات متعددة، يُتاح لك خيار عرض متوسط الدرجات أو تحديد الاستبيانات التي ترغب في مقارنتها للحصول على تحليل مخصص. "
      },
      {
        "language": "EN",
        "text": "Select the companies (if any) you want to compare. </br>Hint: if you have multiple surveys, you have the option to view average scores or select surveys for a tailored analysis! "
      }
    ]
  },
  {
    "key": "txt_Companies_799",
    "text": "Companies ",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات "
      },
      {
        "language": "EN",
        "text": "Companies "
      }
    ]
  },
  {
    "key": "txt_Selectthe_681",
    "text": "Select the start and end dates to view the analysis for a specific timeframe. ",
    "translations": [
      {
        "language": "AR",
        "text": "لعرض نتائج جاهزية الذكاء الاصطناعي لفترة زمنية معينة، قم باختيار تواريخ البداية والنهاية. "
      },
      {
        "language": "EN",
        "text": "Select the start and end dates to view the analysis for a specific timeframe. "
      }
    ]
  },
  {
    "key": "txtComparison_wellbeing",
    "text": "Ready to uncover your survey history's top AI readiness scores and compare them across years and companies (if any)? Discover the answer now! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج جاهزية الذكاء الاصطناعي ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن! "
      },
      {
        "language": "EN",
        "text": "Ready to uncover your survey history's top AI readiness scores and compare them across years and companies (if any)? Discover the answer now! "
      }
    ]
  },
  {
    "key": "txt_Compariso_275",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة "
      },
      {
        "language": "EN",
        "text": "Comparison"
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالضغط هنا."
      },
      {
        "language": "EN",
        "text": "Change the type of the chart by clicking here."
      }
    ]
  },
  {
    "key": "txt_Clickhere_159",
    "text": "Click here to download all comments.</br>Note: Available in Excel format ",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات. </br> ملحوظة: متوفر في صيغة Excel. "
      },
      {
        "language": "EN",
        "text": "Click here to download all comments.</br>Note: Available in Excel format "
      }
    ]
  },
  {
    "key": "txtComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      },
      {
        "language": "EN",
        "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! "
      }
    ]
  },
  {
    "key": "txtRespondentComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txtRespondentComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback!",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback!"
      }
    ]
  },
  {
    "key": "txt_Expandthe_792",
    "text": "Expand the pillars to view each statement score and the distribution of respondents’ answers. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الركائز لعرض متوسط كل عبارة وتوزيع إجابات المستجيبين. "
      },
      {
        "language": "EN",
        "text": "Expand the pillars to view each statement score and the distribution of respondents’ answers. "
      }
    ]
  },
  {
    "key": "txt_Statement_817",
    "text": "Statements’ Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات "
      },
      {
        "language": "EN",
        "text": "Statements’ Score"
      }
    ]
  },
  {
    "key": "txt_questions_desc",
    "text": "In \"Statements\", each pillar score with its corresponding sub-pillar is shown.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل ركيزة مع العبارات الخاصة به."
      },
      {
        "language": "EN",
        "text": "In \"Statements\", each pillar score with its corresponding sub-pillar is shown."
      }
    ]
  },
  {
    "key": "txt_ChartType_839",
    "text": "Chart Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني "
      },
      {
        "language": "EN",
        "text": "Chart Type "
      }
    ]
  },
  {
    "key": "txtResponses_desc",
    "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the survey setup step. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليل المستجيبون\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المخُتارة في خطوة إعداد الاستبيان."
      },
      {
        "language": "EN",
        "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the survey setup step. "
      }
    ]
  },
  {
    "key": "txt_Elevateyo_771",
    "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "ارفع مستوى التحليلات بنقرة واحدة - قم بتحميل مخطط تمثيل البيانات بالألوان الخاصة بك!<br><br>ملحوظة: متوفرة في صيغة Excel."
      },
      {
        "language": "EN",
        "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format"
      }
    ]
  },
  {
    "key": "txt_ExpandDim_862",
    "text": "Expand Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الركائز"
      },
      {
        "language": "EN",
        "text": "Expand Pillars"
      }
    ]
  },
  {
    "key": "txt_Clickonea_896",
    "text": "Click on each pillar to expand the results of their statements. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على كل ركيزة لعرض نتائج العبارات الخاصة بهم. "
      },
      {
        "language": "EN",
        "text": "Click on each pillar to expand the results of their statements. "
      }
    ]
  },
  {
    "key": "txt_Discovert_892",
    "text": "Discover a summarized analysis of the survey's key highlights and insights. Compare the percentage difference in overall score, pillars, and statements against demographics or custom criteria using the Breakout dropdown.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف أبرز النقاط الرئيسية للاستبيان في تحليل مُلخص! قارن الفرق في النسب بين الدرجة الكلية والركائز والعبارات بالنسبة إلى الجوانب الديموغرافية والمعايير المخصصة وذلك من خلال القائمة المنسدلة \"تفصيل حسب\"."
      },
      {
        "language": "EN",
        "text": "Discover a summarized analysis of the survey's key highlights and insights. Compare the percentage difference in overall score, pillars, and statements against demographics or custom criteria using the Breakout dropdown."
      }
    ]
  },
  {
    "key": "txt_Unlockthe_743",
    "text": "Compare AI Readiness scores by employee criteria or by pillar, using the dropdowns to switch the criteria.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات الجاهزية للذكاء الاصطناعي حسب معايير الموظفين أو حسب الركيزة، باستخدام القوائم المنسدلة لتغيير المعايير."
      },
      {
        "language": "EN",
        "text": "Compare AI Readiness scores by employee criteria or by pillar, using the dropdowns to switch the criteria."
      }
    ]
  },
  {
    "key": "txt_Workplace_851",
    "text": "AI Readiness Score by Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي حسب المعايير"
      },
      {
        "language": "EN",
        "text": "AI Readiness Score by Criteria"
      }
    ]
  },
  {
    "key": "txt_Clickhere_702",
    "text": "Click here to <b>download</b> the report and turn on the sections you want to include.<br><br>Hint: Easily access detailed criteria reports by choosing your preferred criteria in the 'filters' menu and start downloading now! - Available in PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا <b>لتحميل التقرير</b> واختر الأقسام التي ترغب في تضمينها في التقرير.<br><br>تلميح: قم بالوصول بسهولة إلى تقارير المعايير التحليلية المفصلة عن طريق اختيار المعيار في قائمة \"التصفية\" وابدأ بالتحميل الآن! - متوفر في صيغة PDF."
      },
      {
        "language": "EN",
        "text": "Click here to <b>download</b> the report and turn on the sections you want to include.<br><br>Hint: Easily access detailed criteria reports by choosing your preferred criteria in the 'filters' menu and start downloading now! - Available in PDF."
      }
    ]
  },
  {
    "key": "txt_Clickhere_662",
    "text": "Click here to filter the analysis by choosing the entity.</br> Note: The number of respondents must be at least 3 to view the analysis of each entity. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. </br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل وحدة تنظيمية مختارة. "
      },
      {
        "language": "EN",
        "text": "Click here to filter the analysis by choosing the entity.</br> Note: The number of respondents must be at least 3 to view the analysis of each entity. "
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page shows the AI Readiness scores, detailed comparison and other valuable insights.",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>\"نظرة عامة\"</b> تعرض نتائج جاهزية الذكاء الاصطناعي وتحليل القراءات والبيانات بشكل مفصّل ومعمّق."
      },
      {
        "language": "EN",
        "text": "The <b>“Overview”</b> page shows the AI Readiness scores, detailed comparison and other valuable insights."
      }
    ]
  },
  {
    "key": "txt_step_4",
    "text": "One more step, and you’re ready to go! ",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد الاستبيان! "
      },
      {
        "language": "EN",
        "text": "One more step, and you’re ready to go! "
      }
    ]
  },
  {
    "key": "txt_ClickOn_528",
    "text": "Click on <b>“Close Now”</b> to close the survey.  </br>Note: You cannot add or delete respondents once you close the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>“أغلق الآن”</b> لإغلاق الاستبيان. </br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "EN",
        "text": "Click on <b>“Close Now”</b> to close the survey.  </br>Note: You cannot add or delete respondents once you close the survey. "
      }
    ]
  },
  {
    "key": "txt_CloseSurv_416",
    "text": "Close Survey",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الاستبيان "
      },
      {
        "language": "EN",
        "text": "Close Survey"
      }
    ]
  },
  {
    "key": "txt_Unlocksea_518",
    "text": "Everyone can participate – Reach respondents, even without email, with our general survey link. Click here and start sharing!",
    "translations": [
      {
        "language": "AR",
        "text": "   جميع المستجيبون يستطيعون المشاركة – يمكنك الوصول إلى المستجيبين حتى بدون بريد إلكتروني باستخدام رابط الاستبيان. انقر هنا وابدأ بالمشاركة! "
      },
      {
        "language": "EN",
        "text": "Everyone can participate – Reach respondents, even without email, with our general survey link. Click here and start sharing!"
      }
    ]
  },
  {
    "key": "txt_Diditgobe_889",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكير التلقائي. "
      },
      {
        "language": "EN",
        "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates. "
      }
    ]
  },
  {
    "key": "txt_UpdateDat_941",
    "text": "Update Dates ",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ "
      },
      {
        "language": "EN",
        "text": "Update Dates "
      }
    ]
  },
  {
    "key": "txt_Youcandow_532",
    "text": "You can download the list of respondents with their survey status! </br> Note: Available in Excel format. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة الاستبيان الخاص بهم! </br> ملحوظة: متوفر في صيغة Excel. "
      },
      {
        "language": "EN",
        "text": "You can download the list of respondents with their survey status! </br> Note: Available in Excel format. "
      }
    ]
  },
  {
    "key": "txt_ExportRes_128",
    "text": "Export Respondents ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون "
      },
      {
        "language": "EN",
        "text": "Export Respondents "
      }
    ]
  },
  {
    "key": "txt_Forgottoa_219",
    "text": "Forgot to add a respondent? No worries, click here and start adding. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة. "
      },
      {
        "language": "EN",
        "text": "Forgot to add a respondent? No worries, click here and start adding. "
      }
    ]
  },
  {
    "key": "txt_Sendmanua_129",
    "text": "Send manual reminders or delete the respondent. ",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب. "
      },
      {
        "language": "EN",
        "text": "Send manual reminders or delete the respondent. "
      }
    ]
  },
  {
    "key": "txt_MoreActio_120",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      },
      {
        "language": "EN",
        "text": "More Actions"
      }
    ]
  },
  {
    "key": "txt_Clickhere_145",
    "text": "Click here to send reminders to respondents who did not complete the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للمستجيبين الذين لم يستكملوا الاستبيان. "
      },
      {
        "language": "EN",
        "text": "Click here to send reminders to respondents who did not complete the survey."
      }
    ]
  },
  {
    "key": "txt_Trackyour_168",
    "text": "Track your respondents' progress! You can click here to view the response rate in detail.</br> Note: We recommend a 65% - 75% response rate for a better analysis.",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين! يمكنك النقر هنا لعرض معدل الاستجابة بالتفصيل.</br>ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل. يمكنك عرض المشاركة حسب فئة الموظفين من خلال النقر على معدل الاستجابة."
      },
      {
        "language": "EN",
        "text": "Track your respondents' progress! You can click here to view the response rate in detail.</br> Note: We recommend a 65% - 75% response rate for a better analysis."
      }
    ]
  },
  {
    "key": "txt_Onceyouse_314",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the survey invitations and go live!  ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>“دعوة لاستكمال الاستبيان”</b>، انقر هنا لإرسال دعوات الاستبيان وإطلاق الاستبيان مباشرةً!"
      },
      {
        "language": "EN",
        "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the survey invitations and go live!  "
      }
    ]
  },
  {
    "key": "txt_Invitatio_215",
    "text": "Invitation Template ",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة "
      },
      {
        "language": "EN",
        "text": "Invitation Template "
      }
    ]
  },
  {
    "key": "txt_Customize_781",
    "text": "Customize the invitation email template or use the default template generated by Zenithr. </br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. </br>ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"النموذج الأساسي\". "
      },
      {
        "language": "EN",
        "text": "Customize the invitation email template or use the default template generated by Zenithr. </br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. "
      }
    ]
  },
  {
    "key": "txt_invitation_email_desc",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"دعوة لاستكمال الاستبيان\"</b> تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المستجيبون\"</b> من خلال البريد الإلكتروني."
      },
      {
        "language": "EN",
        "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email. "
      }
    ]
  },
  {
    "key": "txt_Customize_297",
    "text": "Customize the reminder email template or use the default template generated by Zenithr.</br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل التذكير أو استخدم النموذج الأساسي المُعرف من زينثر .</br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"<b>النموذج الأساسي</b>\"."
      },
      {
        "language": "EN",
        "text": "Customize the reminder email template or use the default template generated by Zenithr.</br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. "
      }
    ]
  },
  {
    "key": "txt_Addupto3a_148",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا الاستبيان. "
      },
      {
        "language": "EN",
        "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the survey. "
      }
    ]
  },
  {
    "key": "txt_Automated_437",
    "text": "Automated Reminders ",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية "
      },
      {
        "language": "EN",
        "text": "Automated Reminders "
      }
    ]
  },
  {
    "key": "txt_Setthecom_342",
    "text": "Set the completion date of your survey!<br><br> Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال الاستبيان! <br><br>تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      },
      {
        "language": "EN",
        "text": "Set the completion date of your survey!<br><br> Hint: You can extend the completion date after you send the invitations!"
      }
    ]
  },
  {
    "key": "txt_SurveyDea_220",
    "text": "Survey Deadline ",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال الاستبيان "
      },
      {
        "language": "EN",
        "text": "Survey Deadline "
      }
    ]
  },
  {
    "key": "txt_timeframe_desc",
    "text": "In <b>“Timeframe”</b>, you set the survey deadline in addition to automated reminders. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>“المدة الزمنية”</b>، يمكنك تحديد الإطار الزمني للاستبيان بالإضافة إلى تذكيرات تلقائية لاستكمال الاستبيان."
      },
      {
        "language": "EN",
        "text": "In <b>“Timeframe”</b>, you set the survey deadline in addition to automated reminders. "
      }
    ]
  },
  {
    "key": "txt_Tostartad_220",
    "text": "To start adding respondents, click on <b>“Add Respondent”</b>.</br> Hint: We recommend adding by using Excel to save time and simplify your experience! ",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>“إضافة مستجيب”</b>. <br/> تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      },
      {
        "language": "EN",
        "text": "To start adding respondents, click on <b>“Add Respondent”</b>.</br> Hint: We recommend adding by using Excel to save time and simplify your experience! "
      }
    ]
  },
  {
    "key": "txt_respondents_desc",
    "text": "In the <b>“Respondents”</b> page, you add the Respondents you want to invite to the survey manually, or by Excel file, or from your respondent pool. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المستجيبون\"</b>، يمكنك إضافة المستجيبين الذين ترغب في دعوتهم للاستبيان يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      },
      {
        "language": "EN",
        "text": "In the <b>“Respondents”</b> page, you add the Respondents you want to invite to the survey manually, or by Excel file, or from your respondent pool. "
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء الاستبيان."
      },
      {
        "language": "EN",
        "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the survey."
      }
    ]
  },
  {
    "key": "txt_Responden_431",
    "text": "Respondent Information ",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب "
      },
      {
        "language": "EN",
        "text": "Respondent Information "
      }
    ]
  },
  {
    "key": "txt_CustomCri_149",
    "text": "Custom Criteria ",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Criteria "
      }
    ]
  },
  {
    "key": "txt_Youcancre_632",
    "text": "You can create additional criteria. </br>Fill in the criterion name and its options. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية. </br>قم بتعبئة اسم المعيار وخياراته."
      },
      {
        "language": "EN",
        "text": "You can create additional criteria. </br>Fill in the criterion name and its options. "
      }
    ]
  },
  {
    "key": "txt_analytical_criteria_desc",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive, detailed analysis and comparison!",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br><br>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!"
      },
      {
        "language": "EN",
        "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive, detailed analysis and comparison!"
      }
    ]
  },
  {
    "key": "txt_Nextstep_435",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "Next step!"
      }
    ]
  },
  {
    "key": "txt_step_1",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "The first step is done; click here for the next step."
      }
    ]
  },
  {
    "key": "txt_step_2",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      },
      {
        "language": "EN",
        "text": "Another step is done; click here for the next step."
      }
    ]
  },
  {
    "key": "txt_step_3",
    "text": "You are ready to go to the next step! ",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      },
      {
        "language": "EN",
        "text": "You are ready to go to the next step! "
      }
    ]
  },
  {
    "key": "txt_Clickonb_749",
    "text": "Click on <b>“Preview Survey”</b> to view your Survey's selected pillars and statements! </br>  Note: Available in PDF format. To download click “📁”. ",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على <b>“عرض الاستبيان”</b> لعرض الركائز والعبارات المختارة في الاستبيان الخاص بك! </br> ملاحظة: متوفر بصيغة PDF. لتنزيل الملف اضغط على “📁”."
      },
      {
        "language": "EN",
        "text": "Click on <b>“Preview Survey”</b> to view your Survey's selected pillars and statements! </br>  Note: Available in PDF format. To download click “📁”. "
      }
    ]
  },
  {
    "key": "txt_Useouradv_513",
    "text": "Use our advanced AI tool to generate statements tailored to your need! ",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك! "
      },
      {
        "language": "EN",
        "text": "Use our advanced AI tool to generate statements tailored to your need! "
      }
    ]
  },
  {
    "key": "txt_GenerateS_831",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      },
      {
        "language": "EN",
        "text": "Generate Statement "
      }
    ]
  },
  {
    "key": "txt_ClickOnStatement",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. </br>Hint: Click “👁️” to preview the statement sample used in the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على<b> \"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق.</br> تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في الاستبيان. "
      },
      {
        "language": "EN",
        "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. </br>Hint: Click “👁️” to preview the statement sample used in the survey. "
      }
    ]
  },
  {
    "key": "txt_AddStatem_838",
    "text": "Add Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة "
      },
      {
        "language": "EN",
        "text": "Add Statement "
      }
    ]
  },
  {
    "key": "txt_EditCusto_165",
    "text": "Edit Custom Pillar ",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الركيزة المخصص "
      },
      {
        "language": "EN",
        "text": "Edit Custom Pillar "
      }
    ]
  },
  {
    "key": "txt_Editordel_801",
    "text": "Edit or delete the new custom pillar. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف الركيزة المخصص الجديد. "
      },
      {
        "language": "EN",
        "text": "Edit or delete the new custom pillar. "
      }
    ]
  },
  {
    "key": "txtCustomDimensions_desc",
    "text": "If you want to add more statements, first click <b>“New Custom Pillar”</b>.</br> Note: Total Pillars covering the <b>Predefined</b> and <b>Custom Pillars</b> shall not exceed 8 Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على<b> \"بعد مخصص جديد\"</b>. </br>ملحوظة: يجب ألا يتجاوز إجمالي الركائز <b>المُعرفة مسبقاُ</b> و<b>المخصصة </b>عن 8 ركائز. "
      },
      {
        "language": "EN",
        "text": "If you want to add more statements, first click <b>“New Custom Pillar”</b>.</br> Note: Total Pillars covering the <b>Predefined</b> and <b>Custom Pillars</b> shall not exceed 8 Pillars"
      }
    ]
  },
  {
    "key": "txtDimensions_desc",
    "text": "To find out if your organization is AI-ready, use the full <b>READY pillars</b> for a comprehensive readiness score.",
    "translations": [
      {
        "language": "AR",
        "text": "لمعرفة مدى جاهزية مؤسستك لتبني الذكاء الاصطناعي، استخدم <b>ركائز READY</b> الكاملة للحصول على درجة جاهزية شاملة."
      },
      {
        "language": "EN",
        "text": "To find out if your organization is AI-ready, use the full <b>READY pillars</b> for a comprehensive readiness score."
      }
    ]
  },
  {
    "key": "txtDimensions_name",
    "text": "READY Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز READY"
      },
      {
        "language": "EN",
        "text": "READY Pillars"
      }
    ]
  },
  {
    "key": "txt_translation_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! "
      }
    ]
  },
  {
    "key": "txt_Translati_697",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "EN",
        "text": "Translation"
      }
    ]
  },
  {
    "key": "txt_Fillinyou_655",
    "text": "Fill in your <b>\"Survey Name\"</b>. </br></br> You can add a description as well. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة <b>اسم الاستبيان</b>.</br></br> يمكنك أيضاً إضافة وصف للاستبيان."
      },
      {
        "language": "EN",
        "text": "Fill in your <b>\"Survey Name\"</b>. </br></br> You can add a description as well. "
      }
    ]
  },
  {
    "key": "txt_SurveyDet_371",
    "text": "Survey Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الاستبيان "
      },
      {
        "language": "EN",
        "text": "Survey Details"
      }
    ]
  },
  {
    "key": "txt_survey_info_desc",
    "text": "In <b>“Survey Information</b>”, you specify the main elements, including survey name and pillars & statements! ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"معلومات الاستبيان\"</b> تُحدد العناصر الرئيسية، بما في ذلك اسم الاستبيان والركائز والعبارات."
      },
      {
        "language": "EN",
        "text": "In <b>“Survey Information</b>”, you specify the main elements, including survey name and pillars & statements! "
      }
    ]
  },
  {
    "key": "txt_Clickhere_208",
    "text": "Click here to delete a draft survey.<br><br> Note: only draft surveys can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف الاستبيانات المسودة. <br><br>ملحوظة: يمكن حذف استبيانات المسودة فقط"
      },
      {
        "language": "EN",
        "text": "Click here to delete a draft survey.<br><br> Note: only draft surveys can be deleted"
      }
    ]
  },
  {
    "key": "txt_DeleteSur_232",
    "text": "Delete Survey",
    "translations": [
      {
        "language": "AR",
        "text": "حذف استبيان "
      },
      {
        "language": "EN",
        "text": "Delete Survey"
      }
    ]
  },
  {
    "key": "txt_Tocreatea_600",
    "text": "To create a new survey, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقرعلى <b>\"إعداد جديد\"</b> لإنشاء استبيان جديد."
      },
      {
        "language": "EN",
        "text": "To create a new survey, click on <b>“New Setup”</b>."
      }
    ]
  },
  {
    "key": "txt_OpenSurve_592",
    "text": "Open Survey ",
    "translations": [
      {
        "language": "AR",
        "text": "فتح استبيان "
      },
      {
        "language": "EN",
        "text": "Open Survey "
      }
    ]
  },
  {
    "key": "txt_Pointthem_434",
    "text": "Point the mouse over the survey list to open draft, live, and closed surveys. ",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة الاستبيانات لفتح الاستبيانات بحالة المسودة، المباشرة، والمنتهية."
      },
      {
        "language": "EN",
        "text": "Point the mouse over the survey list to open draft, live, and closed surveys. "
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      },
      {
        "language": "EN",
        "text": "Preparing Heatmap"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      },
      {
        "language": "EN",
        "text": "Download Heatmap"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Disagree"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Agree"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Strongly Disagree"
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Strongly Agree"
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      },
      {
        "language": "EN",
        "text": "Respondents"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      },
      {
        "language": "EN",
        "text": "Apply"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      },
      {
        "language": "EN",
        "text": "Selected Entity"
      }
    ]
  },
  {
    "key": "txt_dates_error",
    "text": "date error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ في التاريخ"
      },
      {
        "language": "EN",
        "text": "date error"
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      },
      {
        "language": "EN",
        "text": "No Sentiment"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3001",
    "text": "Invalid emails",
    "translations": [
      {
        "language": "AR",
        "text": "بريد الكتروني غير صالح"
      },
      {
        "language": "EN",
        "text": "Invalid emails"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3000",
    "text": "Duplication Emails in Excel Sheet",
    "translations": [
      {
        "language": "AR",
        "text": "تكرار البريد الإلكتروني في ورقة إكسل"
      },
      {
        "language": "EN",
        "text": "Duplication Emails in Excel Sheet"
      }
    ]
  },
  {
    "key": "txtWokplaceWellbeingEx",
    "text": "AI Readiness Experience By",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جاهزية الذكاء الاصطناعي في مكان العمل حسب"
      },
      {
        "language": "EN",
        "text": "AI Readiness Experience By"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "EN",
        "text": "Search"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "EN",
        "text": "Progress"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "EN",
        "text": "Email"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "EN",
        "text": "Name"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "EN",
        "text": "Employee ID"
      }
    ]
  },
  {
    "key": "txtIndex",
    "text": "Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر"
      },
      {
        "language": "EN",
        "text": "Index"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "EN",
        "text": "Neutral"
      }
    ]
  },
  {
    "key": "txtWellbeing",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txtCommentAiChartTitle",
    "text": "Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات التعليقات"
      },
      {
        "language": "EN",
        "text": "Comments’ Analysis"
      }
    ]
  },
  {
    "key": "txtNeutralAISection",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      },
      {
        "language": "EN",
        "text": "Neutral"
      }
    ]
  },
  {
    "key": "txtNegative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      },
      {
        "language": "EN",
        "text": "Negative"
      }
    ]
  },
  {
    "key": "txtPositive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      },
      {
        "language": "EN",
        "text": "Positive"
      }
    ]
  },
  {
    "key": "txtAtleastRespondentsRequired",
    "text": "At least 3 respondents should complete the survey in order to close it",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      },
      {
        "language": "EN",
        "text": "At least 3 respondents should complete the survey in order to close it"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      },
      {
        "language": "EN",
        "text": "Distribution"
      }
    ]
  },
  {
    "key": "txtStatement",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "EN",
        "text": "Statement"
      }
    ]
  },
  {
    "key": "Applied Filters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر المُطبَّقة"
      },
      {
        "language": "EN",
        "text": "Applied Filters"
      }
    ]
  },
  {
    "key": "Performance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "EN",
        "text": "Performance"
      }
    ]
  },
  {
    "key": "Tenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      },
      {
        "language": "EN",
        "text": "Tenure"
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      },
      {
        "language": "EN",
        "text": "HR Metrics"
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "التركيبة السكانية"
      },
      {
        "language": "EN",
        "text": "Demographics"
      }
    ]
  },
  {
    "key": "Extra Criteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      },
      {
        "language": "EN",
        "text": "Extra Criteria"
      }
    ]
  },
  {
    "key": "Business Level",
    "text": "Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      },
      {
        "language": "EN",
        "text": "Business Level"
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grades",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الوظيفية"
      },
      {
        "language": "EN",
        "text": "Job Grades"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Levels",
    "translations": [
      {
        "language": "AR",
        "text": "المستويات الوظيفية"
      },
      {
        "language": "EN",
        "text": "Band Levels"
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rates",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات الأداء"
      },
      {
        "language": "EN",
        "text": "Performance Rates"
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Groups",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      },
      {
        "language": "EN",
        "text": "Tenure Groups"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Groups",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      },
      {
        "language": "EN",
        "text": "Age Groups"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      },
      {
        "language": "EN",
        "text": "Generation"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "EN",
        "text": "Gender"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "EN",
        "text": "Nationality"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondentsToStart",
    "text": "At least one respondent is needed to proceed",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مستجيب واحد على الأقل"
      },
      {
        "language": "EN",
        "text": "At least one respondent is needed to proceed"
      }
    ]
  },
  {
    "key": "txtDriver/Question",
    "text": "Pillar / statement",
    "translations": [
      {
        "language": "AR",
        "text": "الركيزة/العبارة"
      },
      {
        "language": "EN",
        "text": "Pillar / statement"
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceWellbeing",
    "text": "AI Readiness Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Pillars"
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "EN",
        "text": "Statements"
      }
    ]
  },
  {
    "key": "txtEmployeeIndexByDimension",
    "text": "AI Readiness Index by Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي حسب الركيزة"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index by Pillar"
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations3",
    "text": "Create a financial wellness program and policy. Establish a Financial AI Readiness Fund by allocating a specific percentage of the organization’s revenue. Implement various initiatives, including earned salary access, debt counseling, upskilling support, and hardship loans, to improve employees' financial AI readiness. Regularly track the number of employees benefiting from each initiative and review their effectiveness. Additionally, offer benefits such as life and health insurance, housing, and caregiving allowances to further support employees' financial stability. The organization may prioritize interventions for junior or lower wage bracket employees. These efforts will contribute to creating a resilient and financially secure workforce.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء برنامج وسياسة جاهزية الذكاء الاصطناعي المالية. يمكن للمؤسسة تخصيص نسبة محددة من إيراداتها لإنشاء صندوق يساهم في جاهزية الذكاء الاصطناعي المالية للموظفين بشكل دوري. كما يمكن للمؤسسة تنفيذ مبادرات متنوعة في هذا المجال، بما في ذلك قدرة الموظف على الوصول إلى الراتب المكتسب، والإرشاد المالي، ودعم التطوير المهني، والقروض العُسرية، لتحسين جاهزية الذكاء الاصطناعي المالية. يجب على المؤسسة مراقبة عدد الموظفين الذين يستفيدون من كل مبادرة ومدى فعالية هذه المبادرات بانتظام. بالإضافة إلى ذلك يمكن للمؤسسة تقديم فوائد مثل التأمين على الحياة، والتأمين الصحي، وبدلات السكن والرعاية، وذلك لدعم استقرار الموظفين المالي بشكل أكبر (قد تعطي المؤسسة الأولوية للموظفين الجُدد أو ذوي الأجور المنخفضة). ستساهم هذه الجهود في خلق بيئة عمل متينة و آمنة مالياً."
      },
      {
        "language": "EN",
        "text": "Create a financial wellness program and policy. Establish a Financial AI Readiness Fund by allocating a specific percentage of the organization’s revenue. Implement various initiatives, including earned salary access, debt counseling, upskilling support, and hardship loans, to improve employees' financial AI readiness. Regularly track the number of employees benefiting from each initiative and review their effectiveness. Additionally, offer benefits such as life and health insurance, housing, and caregiving allowances to further support employees' financial stability. The organization may prioritize interventions for junior or lower wage bracket employees. These efforts will contribute to creating a resilient and financially secure workforce."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations2",
    "text": "Improve pay equity and pay equality. Ensure equal pay and benefits for all employees engaged in similar work in alignment with industry standards and organization resources, irrespective of their background. Establish a transparent reward and pay distribution process based on comprehensive job role evaluations. This initiative will enhance trust and foster a sense of fairness among employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تحسين مفهوم المساواة في الأجور لكافة الجوانب. يجب أن يحصل جميع الموظفين على رواتب ومزايا متساوية للأعمال المتماثلة وبما يتوافق مع معايير العمل وموارد المؤسسة ، و بغض النظر عن خلفيتهم القادمين منها. اتباع عملية عادلة في دفع الأجور وإعطاء المكافآت مبنية على تقييمات مسؤوليات الوظائف يساهم في تعزيز الثقة والشعور بالإنصاف بين الموظفين."
      },
      {
        "language": "EN",
        "text": "Improve pay equity and pay equality. Ensure equal pay and benefits for all employees engaged in similar work in alignment with industry standards and organization resources, irrespective of their background. Establish a transparent reward and pay distribution process based on comprehensive job role evaluations. This initiative will enhance trust and foster a sense of fairness among employees."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations1",
    "text": "Ensure fair pay and employee benefits. Implement a feasible base salary increase, secure working hours, and reduce compensation-related worries by ensuring regular and timely salary payments. This initiative must address living situation changes and align with the organization's financial resources.",
    "translations": [
      {
        "language": "AR",
        "text": "ضمان رواتب ومزايا عادلة لجميع الموظفين. ترتبط جاهزية الذكاء الاصطناعي المالية ارتباطاً وثيقاً بدخل الموظف. وبالتالي، يجب التأكد من حصول الموظفين على راتب أساسي معقول قابل للزيادة، وساعات عمل آمنة. وكذلك، وضمان دفع رواتب منتظمة وفي الوقت المحدد، لتقليل القلق المرتبط بالتعويضات. لتطبيق ما ذكر أعلاه يجب الأخذ بعين الاعتبار التغيرات المستمرة في ظروف المعيشة و التوافق مع موارد المؤسسة المالية."
      },
      {
        "language": "EN",
        "text": "Ensure fair pay and employee benefits. Implement a feasible base salary increase, secure working hours, and reduce compensation-related worries by ensuring regular and timely salary payments. This initiative must address living situation changes and align with the organization's financial resources."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations3",
    "text": "Support employees to upskill and find meaning. Provide employees access to on-demand learning platforms (Udemy, Coursera, LinkedIn Learning etc.) and subsidize upskilling costs to enhance their skill sets. Additionally, allocate 3-4 hours weekly to learn skills for their future roles. Schedule regular feedback, coaching, and career counseling sessions to support employees in adapting to changes in their job roles and identify employees' strengths, weaknesses, interests, values, and potential. These initiatives can also help employees reframe their outlook toward the job to make it more meaningful.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم الموظفين لتعزيز مهاراتهم وجعلها ذات مغزى. يمكن للمؤسسة أن توفر للموظفين إمكانية تعزيز مهاراتهم من خلال الاستثمار في منصات التعلم (Udemy, Coursera, LinkedIn Learning). ويمكن للمؤسسة إعطاء الأولوية لتعزيز مهارات الموظفين من خلال تخصيص بضع ساعات (3-4 ساعات) أسبوعياً لتعلم المهارات التي ستساعدهم في دورهم المستقبلي. بالإضافة إلى ذلك، قد تحدد المؤسسات بعض الوقت لتلقي ردود الموظفين، وتقديم خدمات التدريب، وخدمات الإرشاد المهني لمساعدة الموظفين على التكيف مع التغييرات في أدوارهم الوظيفية. كما يمكنهم أيضاً تحديد نقاط القوة والضعف والإمكانات لدى الموظفين. يمكن أن تساعد هذه المبادرات الموظفين على إعادة صياغة نظرتهم للوظيفة لجعلها أكثر جدوى."
      },
      {
        "language": "EN",
        "text": "Support employees to upskill and find meaning. Provide employees access to on-demand learning platforms (Udemy, Coursera, LinkedIn Learning etc.) and subsidize upskilling costs to enhance their skill sets. Additionally, allocate 3-4 hours weekly to learn skills for their future roles. Schedule regular feedback, coaching, and career counseling sessions to support employees in adapting to changes in their job roles and identify employees' strengths, weaknesses, interests, values, and potential. These initiatives can also help employees reframe their outlook toward the job to make it more meaningful."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations2",
    "text": "Consider redesigning the job role. Annually, conduct reflective sessions with the team to identify aspects of their roles that energize and drain them. Utilize this information to enhance job roles and leverage team strengths proactively. Implement automation, digitalization, and innovative solutions to optimize productivity and efficiency. Engage employees in high-value tasks to benefit the organization and its customers. Regularly evaluate progress to ensure continuous improvement.",
    "translations": [
      {
        "language": "AR",
        "text": "النظر في إعادة تصميم الدور الوظيفي. مع تطور الأدوار والمسؤوليات الوظيفية، فإنه يصبح من الضروري التفكير سنوياً مع الفريق في جوانب دورهم الوظيفي التي تعمل على تنشيطهم وتحفيزهم. ستساعد هذه المعلومات المؤسسة على تحسين الأدوار الوظيفية والاستفادة دورياً من نقاط قوة الفريق، كما يمكن للمؤسسة  تطبيق عمليات الأتمتة والرقمنة والحلول الابتكارية لتحسين الإنتاجية والكفاءة، بالإضافة إلى إشراك الموظفين في مهام ذات قيمة عالية لصالح المؤسسة وعملائها. يجب على المؤسسة القيام بتقييم التقدم بانتظام لضمان التحسين المستمر."
      },
      {
        "language": "EN",
        "text": "Consider redesigning the job role. Annually, conduct reflective sessions with the team to identify aspects of their roles that energize and drain them. Utilize this information to enhance job roles and leverage team strengths proactively. Implement automation, digitalization, and innovative solutions to optimize productivity and efficiency. Engage employees in high-value tasks to benefit the organization and its customers. Regularly evaluate progress to ensure continuous improvement."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations1",
    "text": "Connect employees to the big picture. Offer opportunities for employees to learn about the organization's vision and how their role contributes to achieving it. Show employees how the leadership is committed to the organization's vision and impact through their actions and behavior.  Additionally, show appreciation for employees who contribute to the organization's vision through public recognition, bonuses, promotions, or other incentives.",
    "translations": [
      {
        "language": "AR",
        "text": "ربط الموظفين بالرؤية الشاملة للمؤسسة. منح فرص للموظفين للتعرف على رؤية المؤسسة وعلى كيفية مساهمة دورهم في تحقيقها. على المؤسسة أن تظهر لموظفيها كيف تلتزم القيادة برؤية المؤسسة وتأثير أفعالهم وسلوكهم على ذلك. كما يمكن للمؤسسة أيضاً إظهار التقدير للموظفين الذين يساهمون في تحقيق رؤية المؤسسة من خلال إظهار التقدير أو إعطاء المكافآت أو الترقيات أو غيرها من الحوافز."
      },
      {
        "language": "EN",
        "text": "Connect employees to the big picture. Offer opportunities for employees to learn about the organization's vision and how their role contributes to achieving it. Show employees how the leadership is committed to the organization's vision and impact through their actions and behavior.  Additionally, show appreciation for employees who contribute to the organization's vision through public recognition, bonuses, promotions, or other incentives."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations4",
    "text": "Increase Transparency and Personal Accountability. Ensure managers foster a sense of accountability by setting individual and team goals and regularly reviewing progress towards these goals. Build trust and improve collaboration by demonstrating integrity, involving the team in crucial decisions, and recognizing individual contributors in collaborative projects.",
    "translations": [
      {
        "language": "AR",
        "text": "رفع مستوى الشفافية والمساءلة الشخصية. يمكن للمدراء تعزيز شعور المساءلة من خلال تحديد الأهداف الفردية والجماعية، ومراجعة التقدم المحرز في تحقيق هذه الأهداف بشكل دوري. كما يمكن للمدراء بناء الثقة وتعزيز التعاون من خلال إظهار النزاهة، وإشراك الفريق في اتخاذ القرارات الحاسمة، وتقدير المساهمين الفرديين في المشاريع التعاونية."
      },
      {
        "language": "EN",
        "text": "Increase Transparency and Personal Accountability. Ensure managers foster a sense of accountability by setting individual and team goals and regularly reviewing progress towards these goals. Build trust and improve collaboration by demonstrating integrity, involving the team in crucial decisions, and recognizing individual contributors in collaborative projects."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations3",
    "text": "Foster a sense of community. Create a sense of belonging and community within the workplace. Some initiatives the organization can consider include starting an employee-run book club, organizing an organizational sports league, or setting up an employee-run mentoring program. Encourage employees to donate their time, energy, and resources to support causes and communities as part of their corporate social responsibility initiatives. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز الشعور بالانتماء للمؤسسة. خلق شعور بالانتماء والوحدة داخل مكان العمل. وتتضمن بعض المبادرات التي يمكن للمؤسسة التفكير فيها  إنشاء نادي للقراءة يديره الموظفون أو تنظيم دوري رياضي للمؤسسة أو إعداد برنامج توجيه يديره الموظفون. وقد تشجع المؤسسة أيضاً الموظفين على التبرع بوقتهم وطاقتهم ومواردهم لجعلهم يرغبون في تقديم الدعم بشكل جماعي باعتبارهم مجتمعاً واحداً  كجزء من مساهمتهم في مبادرات المسؤولية الاجتماعية."
      },
      {
        "language": "EN",
        "text": "Foster a sense of community. Create a sense of belonging and community within the workplace. Some initiatives the organization can consider include starting an employee-run book club, organizing an organizational sports league, or setting up an employee-run mentoring program. Encourage employees to donate their time, energy, and resources to support causes and communities as part of their corporate social responsibility initiatives. "
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations2",
    "text": "Encourage collaboration. Create opportunities for employees to collaborate on projects and initiatives and provide the necessary resources and support to collaborate successfully. Some valuable resources include training on teamwork, providing tools and technology that facilitate collaboration, and recognizing and rewarding successful partnerships. ",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع التعاون. خلق فرص للموظفين للتعاون في المشاريع والمبادرات وتوفير الموارد اللازمة والدعم للتعاون بنجاح. وتتضمن بعض الموارد القيمة التدريب على العمل الجماعي، وتوفير الأدوات والتكنولوجيا التي تسهل التعاون، وتقدير الشراكات الناجحة ومكافأتها."
      },
      {
        "language": "EN",
        "text": "Encourage collaboration. Create opportunities for employees to collaborate on projects and initiatives and provide the necessary resources and support to collaborate successfully. Some valuable resources include training on teamwork, providing tools and technology that facilitate collaboration, and recognizing and rewarding successful partnerships. "
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations1",
    "text": "Promote open communication. Encourage employees to communicate openly, honestly, and respectfully with each other and their managers. Ensure regular team meetings, one-on-one check-ins, and create channels for informal communication (tea breaks, group lunches, games, etc. may help). Empower managers to show genuine interest and empathy towards their employees to create a supportive work environment and improve team morale.",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز التواصل المفتوح. تشجيع الموظفين على التواصل بصراحة وصدق واحترام مع بعضهم البعض ومع مدرائهم. ويمكن للمؤسسة تحقيق ذلك من خلال عقد اجتماعات دورية للفريق، والتواصل الفردي، ومن خلال إنشاء قنوات للتواصل غير الرسمي (قد يساعد في ذلك أخذ استراحة الشاي أو القهوة، وتناول وجبات غداء جماعية، والألعاب، وما إلى ذلك). يجب على المؤسسة منح المدراء القدرة على التعبير عن اهتمامهم الصادق تجاه موظفيهم لخلق بيئة عمل داعمة وتحسين روح الفريق الواحد."
      },
      {
        "language": "EN",
        "text": "Promote open communication. Encourage employees to communicate openly, honestly, and respectfully with each other and their managers. Ensure regular team meetings, one-on-one check-ins, and create channels for informal communication (tea breaks, group lunches, games, etc. may help). Empower managers to show genuine interest and empathy towards their employees to create a supportive work environment and improve team morale."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations4",
    "text": "Provide training for managers and supervisors. Train managers and supervisors to enhance their understanding of psychological factors, enable them to effectively manage and communicate with employees, and foster a positive and supportive work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير التدريب للمدراء والمسؤولين. يجب على أصحاب العمل تدريب المدراء والمسؤولين لتعزيز فهمهم للعوامل النفسية، وتمكينهم من إدارة الموظفين والتواصل معهم بشكل فعال لتعزيز بيئة عمل إيجابية وداعمة."
      },
      {
        "language": "EN",
        "text": "Provide training for managers and supervisors. Train managers and supervisors to enhance their understanding of psychological factors, enable them to effectively manage and communicate with employees, and foster a positive and supportive work environment."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations3",
    "text": "Address workplace stressors. Conduct regular surveys or employee focus groups to identify specific workplace stress sources. Some everyday stressors include unrealistic deadlines, lack of resources, poor communication, and lack of autonomy. Address negative interactions and toxic behavior, such as bullying or harassment, to improve the psychological AI readiness of employees.",
    "translations": [
      {
        "language": "AR",
        "text": "معالجة ضغوط مكان العمل. يجب على أرباب العمل إجراء استبيانات دورية أو عمل جلسات نقاش مع الموظفين لتحديد المصادر التي تتسبب في حدوث توتر في مكان العمل. وتشمل بعض الضغوطات اليومية المواعيد النهائية غير الواقعية لتسليم الأعمال المنوطة بهم، ونقص الموارد وضعف التواصل والافتقار إلى الاستقلالية. إلى جانب ذلك، يجب على أصحاب العمل معالجة التفاعلات السلبية بين الموظفين والسلوك السيء، مثل التنمر أو التحرش، إلخ."
      },
      {
        "language": "EN",
        "text": "Address workplace stressors. Conduct regular surveys or employee focus groups to identify specific workplace stress sources. Some everyday stressors include unrealistic deadlines, lack of resources, poor communication, and lack of autonomy. Address negative interactions and toxic behavior, such as bullying or harassment, to improve the psychological AI readiness of employees."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations2",
    "text": "Ensure employees can disconnect from work. Ensure employees disconnect from work after work hours and take regular breaks during non-work hours to reduce stress and enhance work-life balance. Additionally, create guidelines for flexible or remote work arrangements to effectively support employees in managing their work and personal responsibilities. ",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الفرص للموظفين للانفصال عن العمل. السماح للموظفين بأخذ فترات راحة منتظمة وقطع التواصل مع العمل بعد ساعات العمل الرسمية لتقليل التوتر وتعزيز التوازن بين العمل والحياة. كما يمكن لأصحاب العمل أيضاً دعم الموظفين من خلال السماح لهم بالعمل بمرونة أو عن ركيزة لتحقيق التوازن بين عملهم ومسؤولياتهم الشخصية بشكل أفضل."
      },
      {
        "language": "EN",
        "text": "Ensure employees can disconnect from work. Ensure employees disconnect from work after work hours and take regular breaks during non-work hours to reduce stress and enhance work-life balance. Additionally, create guidelines for flexible or remote work arrangements to effectively support employees in managing their work and personal responsibilities. "
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations1",
    "text": "Promote a culture of openness and support. Encourage employees to talk openly about their mental health and offer resources such as employee assistance programs, counseling services, and mental health days to support employees in handling stress and maintaining good psychological AI readiness. Provide resources and training on - time management training, relaxation techniques, mindfulness practices, etc.  to help employees handle stress. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز ثقافة الانفتاح والدعم. تشجيع الموظفين على التحدث بصراحة عن صحتهم النفسية، وتقديم الموارد اللازمة لهم مثل برامج مساعدة الموظفين، وخدمات تقديم المشورة، وأيام الصحة النفسية لدعم الموظفين في كيفية معالجة الإجهاد والحفاظ على صحة نفسية جيدة. كما يمكنهم أيضاً توفير الموارد والتدريب لمساعدة الموظفين على كيفية معالجة الإجهاد، مثل التدريب على إدارة الوقت وتقنيات الاسترخاء وممارسات التركيز الذهني."
      },
      {
        "language": "EN",
        "text": "Promote a culture of openness and support. Encourage employees to talk openly about their mental health and offer resources such as employee assistance programs, counseling services, and mental health days to support employees in handling stress and maintaining good psychological AI readiness. Provide resources and training on - time management training, relaxation techniques, mindfulness practices, etc.  to help employees handle stress. "
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "التوصييات"
      },
      {
        "language": "EN",
        "text": "Recommendations"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations4",
    "text": "Communicate effectively. Establish an efficient communication system to effectively relay health and safety information to employees. Provide comprehensive guidance on potential hazards, incident reporting, and updates on policies and procedures. Ensure clarity regarding employee rights, responsibilities, and points of contact for inquiries or concerns. Regularly evaluate the effectiveness of the communication strategy to enhance health and safety awareness and compliance.",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل الفعال. التواصل بشكل فعال مع الموظفين حول مواضيع الصحة والسلامة، بما في ذلك تزويدهم بالمعلومات حول المخاطر المحتملة، والإبلاغ عن الحوادث، ومشاركة التحديثات حول السياسات أو الإجراءات الجديدة. وعلاوة على ذلك، ضمان فهم الموظفين لحقوقهم ومسؤولياتهم ومن هي جهات الاتصال التي يجب اللجوء اليها للاستفسارات. يجب على المؤسسة أن تقوم بتقييم فعالية استراتيجية الاتصال بشكل منتظم لتعزيز الوعي بالصحة والسلامة والامتثال."
      },
      {
        "language": "EN",
        "text": "Communicate effectively. Establish an efficient communication system to effectively relay health and safety information to employees. Provide comprehensive guidance on potential hazards, incident reporting, and updates on policies and procedures. Ensure clarity regarding employee rights, responsibilities, and points of contact for inquiries or concerns. Regularly evaluate the effectiveness of the communication strategy to enhance health and safety awareness and compliance."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations3",
    "text": "Promote a healthy lifestyle. Implement a comprehensive employee wellness program to promote regular exercise, healthy eating, and stress management. Provide dedicated spaces for healthy food options and adequate space to encourage employees to take breaks for physical activity and stretching. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز أسلوب حياة صحية. تنفيذ برنامجًا شاملاً يضمن جاهزية الذكاء الاصطناعي ويعزز ممارسة التمارين الرياضية بانتظام، وتحسين عادات التغذية الصحية،  وكيفية إدارة التوتر، بالإضافة إلى توفير خيارات طعام صحية للموظفين ومساحة كافية لتشجيعهم على أخذ فترات راحة لممارسة الأنشطة البدنية."
      },
      {
        "language": "EN",
        "text": "Promote a healthy lifestyle. Implement a comprehensive employee wellness program to promote regular exercise, healthy eating, and stress management. Provide dedicated spaces for healthy food options and adequate space to encourage employees to take breaks for physical activity and stretching. "
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations2",
    "text": "Create an ergonomic work environment: Provide ergonomic furniture and equipment to reduce the risk of injury and strain caused by poor posture, repetitive motions, and other work-related hazards. Provide regular training and education on health and safety topics to all employees. Some activities may include things like first aid, fire safety, and training on specific hazards that are present in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "خلق بيئة عمل مريحة. توفير أثاث ومعدات مريحة للتقليل من مخاطر الإصابات والإجهاد الناجم عن الأوضاع السيئة والتحرك المستمر والمخاطر الأخرى المتعلقة بالعمل. وكذلك، يجب توفير تدريب وتعليم دوري حول مواضيع الصحة والسلامة لجميع الموظفين. وقد تتضمن بعض الأنشطة أشياءً مثل الإسعافات الأولية والوقاية من الحرائق والتدريب على مخاطر معينة موجودة في مكان العمل."
      },
      {
        "language": "EN",
        "text": "Create an ergonomic work environment: Provide ergonomic furniture and equipment to reduce the risk of injury and strain caused by poor posture, repetitive motions, and other work-related hazards. Provide regular training and education on health and safety topics to all employees. Some activities may include things like first aid, fire safety, and training on specific hazards that are present in the workplace."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations1",
    "text": "Introduce wellness leaves. Assess feasibility and introduce wellness leaves for eligible organizations by aligning with labor law and compliance requirements. By the start of the following calendar year, the organization may introduce a wellness leave policy that allows employees to use their accrued sick leave to promote AI readiness and illness prevention (like massages, sleep adjustments, wellness classes, and preventive health screenings). Update policies, inform employees, and monitor the usage of wellness leaves to promote AI readiness and illness prevention. Collaborate with healthcare experts to support employee health and reinforce the organization’s commitment to their AI readiness. ",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز مفهوم الإجازات المرضية إلى إجازات إضافية (وقائية). يمكن للمؤسسات المؤهلة أن تقوم بطرح مفهوم الإجازات الإضافية (الوقائية) وبما بتوافق مع قوانين العمل ومتطلبات الامتثال. يمكن للمؤسسات في بداية العام طرح سياسة تمكن الموظفين من استخدام إجازاتهم المرضية المدفوعة غير المستخدمة لأغراض صحية وقائية مثل الذهاب لجلسات التدليك، وجلسات تعديل دورات النوم، وأخذ دروس عن الصحة الوقائية، هذا وبالإضافة إلى تشجيع الموظفين على القيام وبشكل دوري بعمل فحوصات وتحاليل طبية ووقائية). على المؤسسة أن تقوم بتحديث السياسات فيما يخص هذا المجال، وإبلاغ الموظفين، ورصد ومتابعة استخدام الإجازات الإضافية الوقائية لدعم الرعاية الصحية والوقاية من الأمراض. كما يمكن للمؤسسة التعاون مع خبراء في مجال الرعاية الصحية لدعم صحة الموظفين وتعزيز التزام المؤسسة بالحفاظ على صحتهم وجاهزية الذكاء الاصطناعييتهم."
      },
      {
        "language": "EN",
        "text": "Introduce wellness leaves. Assess feasibility and introduce wellness leaves for eligible organizations by aligning with labor law and compliance requirements. By the start of the following calendar year, the organization may introduce a wellness leave policy that allows employees to use their accrued sick leave to promote AI readiness and illness prevention (like massages, sleep adjustments, wellness classes, and preventive health screenings). Update policies, inform employees, and monitor the usage of wellness leaves to promote AI readiness and illness prevention. Collaborate with healthcare experts to support employee health and reinforce the organization’s commitment to their AI readiness. "
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPDescription",
    "text": "<p>Financial AI readiness refers to a state of financial wellness where employees have enough money to meet their basic needs and can cope with financial shocks like job loss. Employees may face stress because of current money management issues and because they are worried about their future financial security. The most common factors contributing to financial stress are the individual's wealth, knowledge, attitude toward finances, and current economic behavior. Lack of fair compensation and benefits, inflation, unexpected medical expenditure, student loans, stress related to potential layoffs, retirement, and caregiving responsibilities may lead to financial distress in employees.<br><br>Financial AI Readiness assesses if the current workplace provides financial safety and security to its employees. Financial stress can lead to absenteeism (an employee stays away from work without a valid reason) and presenteeism (an employee shows up at work but is not fully engaged) among employees. Financial stress may also decrease organizational commitment; hence they are less likely to be proactive, engaged, and satisfied with their current job. If a company scores low on this pillar, its employees face financial distress or dissatisfaction. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير جاهزية الذكاء الاصطناعي المالية إلى حالة من الاستقرار المالي حيث يكون لدى الفرد ما يكفيه من المال لتلبية احتياجاته الأساسية، ويمكّنه من التعامل مع الصدمات المالية مثل فقدان الوظيفة.  وقد تشكل كيفية إدارة الأموال الحالية والأمن المالي المستقبلي ضغوطاً  كبيرة على الموظفين، وفي هذا السياق، جدير بالذكر أن العوامل الأكثر شيوعاً التي تساهم في الضغوط المالية هي ثروة الفرد الحالية، والمعرفة التي يمتلكها في هذا المجال، وموقفه تجاه الشؤون المالية والسلوك الاقتصادي الحالي. وقد يؤدي عدم وجود تعويضات ومزايا عادلة، والتضخم الاقتصادي، والنفقات الطبية غير المتوقعة، والقروض الطلابية، والضغوط المرتبطة بتسريح العمال، والتقاعد، والمسؤوليات المتعلقة بتقديم الرعاية  إلى ضائقة مالية لدى الموظفين.<br><br>وتُقيّم جاهزية الذكاء الاصطناعي المالية ما إذا كانت المؤسسة توفر الأمن والسلامة المالية لموظفيها. وفي هذا السياق، تجدر الإشارة إلى أن الضغط المالي يؤدي إلى التغيب المستمر عن العمل (يبقى الموظف بعيداً عن العمل دون سبب وجيه) والحضور الشكلي (يتواجد الموظف في العمل ولكنه لا يشارك بشكل كامل)، وقد يؤدي الضغط المالي أيضاً إلى انخفاض مستوى التزامات الموظفين بالعمل في المؤسسة، ووبذلك فإنه من  المرجح أن يكونوا غير استباقيين ومشاركين وراضين عن وظائفهم الحالية. واستناداً إلى ما ذكر أعلاه، إذا سجلت المؤسسة درجات منخفضة في هذا الركيزة، فإن موظفيها يواجهون ضائقة مالية أو حالة عدم رضا.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Financial AI readiness refers to a state of financial wellness where employees have enough money to meet their basic needs and can cope with financial shocks like job loss. Employees may face stress because of current money management issues and because they are worried about their future financial security. The most common factors contributing to financial stress are the individual's wealth, knowledge, attitude toward finances, and current economic behavior. Lack of fair compensation and benefits, inflation, unexpected medical expenditure, student loans, stress related to potential layoffs, retirement, and caregiving responsibilities may lead to financial distress in employees.<br><br>Financial AI Readiness assesses if the current workplace provides financial safety and security to its employees. Financial stress can lead to absenteeism (an employee stays away from work without a valid reason) and presenteeism (an employee shows up at work but is not fully engaged) among employees. Financial stress may also decrease organizational commitment; hence they are less likely to be proactive, engaged, and satisfied with their current job. If a company scores low on this pillar, its employees face financial distress or dissatisfaction. </p>"
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPDescription",
    "text": "<p>\"Occupational AI readiness\" refers to an employee's sense of purpose, growth, and fulfillment. Occupational AI readiness measures the presence of meaning, growth, and positive emotions toward the organization and current profession or job role. This pillar is closely related to employee engagement and satisfies an employee's need to improve and be part of something beyond oneself.<br><br>When people are involved in decisions about their work environment, tasks, and goals, they are likelier to feel that their opinions and ideas are valued. Involving employees can lead to a more positive work culture and satisfying work experience. Similarly, people are more motivated and engaged when they think their work is essential and makes a difference. When employees feel their work matters, it can increase job satisfaction, improving overall AI readiness.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير جاهزية الذكاء الاصطناعي المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم جاهزية الذكاء الاصطناعي المهنية فهم الغرض من الوظيفة الحالية والإحساس بالمشاعر الإيجابية تجاهها وتجاه المؤسسة. هذه الركيزة مرتبط ارتباطًا وثيقًا بالارتباط الوظيفي للموظفين ويفي بحاجتهم للتحسين المستمر وأن يكونوا جزءًا من شيء يتجاوز ذاتهم. تشير جاهزية الذكاء الاصطناعي المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم جاهزية الذكاء الاصطناعي المهنية وجود المغزى والنمو والمشاعر الإيجابية تجاه الوظيفة الحالية للشركة أو دورها الوظيفي. ويرتبط هذا الركيزة ارتباطاً وثيقاً بمشاركة الموظفين، ويلبي حاجة الموظف إلى التحسين وأن يكون جزءاً من شيء يتجاوز مصلحته الشخصية.<br><br>عندما يشارك الموظفين في القرارات المتعلقة ببيئة عملهم ومهامهم وأهدافهم، فمن المرجح أن يشعروا بأن آرائهم وأفكارهم تحظى بالتقدير، ويمكن أن يؤدي إشراك الموظفين بتلك القرارات إلى بروز ثقافة عمل أكثر إيجابية وتجربة عمل مرضية. وبالمثل، يكون الموظفون أكثر حماساً واندماجاً بالعمل عندما يعتقدون أن عملهم ضروري وأنه يحدث فرقاً، وعندما يشعر الموظفون أن عملهم مهم، يمكن أن يؤدي ذلك إلى زيادة الرضا الوظيفي وتعزيز جاهزية الذكاء الاصطناعي العامة.</p>"
      },
      {
        "language": "EN",
        "text": "<p>\"Occupational AI readiness\" refers to an employee's sense of purpose, growth, and fulfillment. Occupational AI readiness measures the presence of meaning, growth, and positive emotions toward the organization and current profession or job role. This pillar is closely related to employee engagement and satisfies an employee's need to improve and be part of something beyond oneself.<br><br>When people are involved in decisions about their work environment, tasks, and goals, they are likelier to feel that their opinions and ideas are valued. Involving employees can lead to a more positive work culture and satisfying work experience. Similarly, people are more motivated and engaged when they think their work is essential and makes a difference. When employees feel their work matters, it can increase job satisfaction, improving overall AI readiness.</p>"
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPDescription",
    "text": "<p>Social AI Readiness is where employees have strong and dependable working relations with coworkers, managers, and clients. It is a crucial component of overall Employee AI readiness and is closely related to physical and mental health. People with a reliable support network feel secure and less anxious or stressed at work. Being part of a community can also boost social AI readiness. <br><br>Social AI readiness assesses whether an organization fosters a culture of trust, personal connection, and social support among its employees. This can boost job satisfaction among employees and improve employee retention.<br><br>Organizations with high scores in this pillar will likely have productivity in teams and roles requiring collaboration and teamwork. These organizations might also have workplace design, practices, and culture that encourage employees to build connections and maintain healthy & meaningful relationships at work.<br><br>The social AI readiness of employees may be poor if employees work remotely or in a hybrid setting, are new, or are marginalized due to their differences. Organizations with low scores may need to investigate and take proactive steps to prevent employees from feeling excluded, lonely, or isolated. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تتمثل جاهزية الذكاء الاصطناعي الاجتماعية في أن يكون للموظفين علاقات عمل قوية وموثوقة مع زملائهم في العمل ومدرائهم وعملائهم. وتعتبر جاهزية الذكاء الاصطناعي الاجتماعية عنصر حاسم في جاهزية الذكاء الاصطناعي بشكل عام، وترتبط ارتباطاً وثيقاً بالصحة الجسدية والنفسية، ويشعر الأشخاص الذين يتمتعون بدعم اجتماعي قوي بالأمان ويكونون أقل قلقاً أو توتراً في مكان العمل. وجدير بالذكر أن كون الشخص جزءاً من مجتمع ما بشكل عام يعزز جاهزية الذكاء الاصطناعي الاجتماعية وبشكل كبير.<br><br>وتقيم جاهزية الذكاء الاصطناعي الاجتماعية عما إذا كانت المؤسسة تعزز ثقافة الثقة والاتصال الشخصي والدعم الاجتماعي بين موظفيها. كما يمكن أن تعزز جاهزية الذكاء الاصطناعي الاجتماعية للموظفين رضاهم الوظيفي وتحسن معدل استبقاء الموظفين.<br><br>ومن المحتمل أن تتمتع المؤسسات ذات الدرجات العالية في هذا الركيزة بالإنتاجية في فرق العمل والمسؤوليات والمهام التي تتطلب التعاون والعمل الجماعي. وقد يكون لهذه المؤسسات أيضاً بيئة عمل وممارسات وثقافة معينة تشجع الموظفين على بناء علاقات صحية وذات مغزى في العمل والحفاظ عليها.<br><br>وقد تكون جاهزية الذكاء الاصطناعي الاجتماعية للموظفين سيئة إذا كان الموظفون يعملون عن بعد أو في بيئة هجينة، أو إذا كانوا جديدين في العمل، أو تم تهميشهم بسبب الاختلافات فيما بينهم. وقد تحتاج المؤسسات ذات الدرجات المنخفضة إلى التحقيق في مدى تطبيقها للجاهزية الذكاء الاصطناعي الاجتماعية للموظفين، واتخاذ خطوات استباقية لمنع الموظفين من الشعور بالتهميش أو الوحدة أو العزلة في العمل.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Social AI Readiness is where employees have strong and dependable working relations with coworkers, managers, and clients. It is a crucial component of overall Employee AI readiness and is closely related to physical and mental health. People with a reliable support network feel secure and less anxious or stressed at work. Being part of a community can also boost social AI readiness. <br><br>Social AI readiness assesses whether an organization fosters a culture of trust, personal connection, and social support among its employees. This can boost job satisfaction among employees and improve employee retention.<br><br>Organizations with high scores in this pillar will likely have productivity in teams and roles requiring collaboration and teamwork. These organizations might also have workplace design, practices, and culture that encourage employees to build connections and maintain healthy & meaningful relationships at work.<br><br>The social AI readiness of employees may be poor if employees work remotely or in a hybrid setting, are new, or are marginalized due to their differences. Organizations with low scores may need to investigate and take proactive steps to prevent employees from feeling excluded, lonely, or isolated. </p>"
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPDescription",
    "text": "<p>Psychological AI readiness refers to mental AI readiness and the ability to disconnect from work to manage personal life. Work-related stressors can affect mental health by making it difficult for employees to balance work and personal responsibilities. Not doing well can further lead to feelings of guilt and inadequacy, which can negatively impact mental health. Psychological AI Readiness assesses whether employees feel their organization cares about their mental health and work-life balance. <br><br>The organization need to identify and address workplace stress sources to promote a healthier and more balanced workforce. <br><br>Work-related Stressors can affect an individual's emotions and lead to various mental health problems, such as anxiety, depression, and even burnout. <br><br>Organizations can improve employee satisfaction, enhance productivity, and reduce absenteeism by prioritizing mental health and work-life balance. Organizations that do not prioritize psychological AI readiness can risk leaving employees emotionally exhausted and indifferent toward their work. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير جاهزية الذكاء الاصطناعي النفسية إلى الصحة العقلية والقدرة على الفصل بين العمل والحياة الشخصية. يمكن أن تؤثر الضغوطات المرتبطة بالعمل على الصحة النفسية من خلال جعل الموظفين في حالة يصعب عليهم فيها الموازنة بين مسؤوليات العمل والمسؤوليات الشخصية مما قد يؤدي إلى الشعور بالذنب وعدم الكفاءة، وبالتالي يؤثر سلباً على صحتهم النفسية. وتُقيّم جاهزية الذكاء الاصطناعي النفسية مدى شعور الموظفين بأن صاحب العمل يهتم بصحتهم النفسية وبقدرتهم على الموازنة بين العمل والحياة الشخصية. ويحتاج أرباب العمل إلى تحديد مصادر الإجهاد في مكان العمل ومعالجتها لتعزيز الصحة النفسية لموظفيهم وقدرتهم على الموازنة بين العمل والحياة.<br><br>كما يمكن أن تؤثر الضغوطات المرتبطة بالعمل على مشاعر الموظف، مما قد يؤدي إلى ظهور العديد من المشاكل النفسية، مثل القلق والاكتئاب وحتى الإرهاق. ويمكن للمؤسسات تحسين مستوى رضا الموظفين وتعزيز الإنتاجية وتقليل التغيب عن العمل عن طريق إعطاء الأولوية للتوازن بين العمل والحياة والصحة النفسية. وقد تبين أن المؤسسات التي لا تعطي الأولوية للصحة النفسية لموظفيها تخاطر بتركهم مرهقين شعورياً وغير مبالين تجاه عملهم.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Psychological AI readiness refers to mental AI readiness and the ability to disconnect from work to manage personal life. Work-related stressors can affect mental health by making it difficult for employees to balance work and personal responsibilities. Not doing well can further lead to feelings of guilt and inadequacy, which can negatively impact mental health. Psychological AI Readiness assesses whether employees feel their organization cares about their mental health and work-life balance. <br><br>The organization need to identify and address workplace stress sources to promote a healthier and more balanced workforce. <br><br>Work-related Stressors can affect an individual's emotions and lead to various mental health problems, such as anxiety, depression, and even burnout. <br><br>Organizations can improve employee satisfaction, enhance productivity, and reduce absenteeism by prioritizing mental health and work-life balance. Organizations that do not prioritize psychological AI readiness can risk leaving employees emotionally exhausted and indifferent toward their work. </p>"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPDescription",
    "text": "<p>Physical AI readiness is the state of optimal physical health and wellness for employees, encompassing the body's overall health and functionality. It covers various elements such as proper nutrition, regular exercise, adequate sleep, and preventative healthcare. The existing design of the workplace and policies can nudge employees toward or away from their physical AI readiness. Physical AI Readiness assesses the physical safety and health of employees at their workplace. Employees' physical AI readiness is essential for a business's success and productivity because it directly affects their ability to perform their duties effectively and efficiently. <br><br>Additionally, physically well employees are more likely to be engaged and motivated, increasing productivity and job satisfaction. In the long term, investing in the physical AI readiness of employees can also lead to lower healthcare costs and a reduction in absenteeism. Organizations with low score must investigate how their workplace design, policies, and procedures can negatively impact physical AI readiness. For example, poor ergonomics, such as poorly designed desks and chairs, can lead to musculoskeletal problems like back pain, neck pain, and carpal tunnel syndrome. Poor lighting and ventilation can also contribute to physical issues, such as eye strain and headaches. Specific policies and procedures can negatively impact physical AI readiness. A culture that discourages taking breaks can lead to fatigue and burnout. Similarly, a lack of flexibility in the work schedule can cause physical health problems. The organization should be mindful of these factors and make necessary adjustments to promote their employees' physical AI readiness.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير جاهزية الذكاء الاصطناعي من الناحية البدنية (الصحية) إلى حالة الصحة الجسدية والعافية المثلى للموظفين، وذلك يشمل عناصر مختلفة مثل التغذية السليمة، وممارسة التمارين الرياضية بانتظام، والنوم الكافي، والرعاية الصحية الوقائية. ويمكن للتصميم الحالي لمكان العمل والسياسات المتبعة فيه أن ترقى بالموظفين نحو جاهزية الذكاء الاصطناعييتهم الصحية أو تأخذهم بعيداً عن تلك جاهزية الذكاء الاصطناعي. وتقيّم جاهزية الذكاء الاصطناعي الصحية مدى السلامة البدنية وصحة الموظفين في مكان عملهم. وتعتبر جاهزية الذكاء الاصطناعي الصحية للموظفين ضرورية لنجاح الأعمال وإنتاجية الموظفين، لأنها تؤثر وبشكل مباشر على قدرتهم على أداء التزاماتهم بفعالية وكفاءة. بالإضافة إلى ذلك، فإنه من المرجح أن يكون الموظفون الذين يتمتعون بصحة جيدة بدنياً أكثر اندماجاً وتحفيزاً، مما يزيد من الإنتاجية والرضا الوظيفي، ويمكن أن يؤدي الاستثمار في جاهزية الذكاء الاصطناعي الصحية للموظفين إلى انخفاض تكاليف الرعاية الصحية وتقليل التغيب عن العمل على المدى الطويل.<br><br>ويجب على المؤسسات ذات الدرجات المنخفضة في هذا الجانب التحقق من كيفية تأثير تصميم مكان العمل والسياسات والإجراءات المتبعة بشكل سلبي على جاهزية الذكاء الاصطناعي الصحية للموظفين، على سبيل المثال، يمكن أن تؤدي بيئة العمل السيئة، مثل المكاتب والكراسي سيئة التصميم، إلى حدوث مشاكل في العضلات والعظام مثل آلام الظهر، وآلام الرقبة، ومتلازمة النفق الرسغي، كما يمكن أن يساهم ضعف الإضاءة والتهوية في حدوث مشكلات جسدية، مثل إجهاد العين والصداع، كما يمكن لبعض السياسات والإجراءات أن تؤثر سلباً على الجاهزية الذكاء الاصطناعي في هذا المنطلق. هذا وكما يمكن أن تؤدي الثقافة التي لا تشجع على أخذ فترات راحة إلى الإجهاد والإرهاق، وبالمثل، فإن عدم وجود مرونة في جدول العمل يمكن أن يسبب مشاكل صحية بدنية، لذلك يجب على أرباب العمل أن يضعوا في اعتبارهم هذه العوامل وأن يقوموا بالتعديلات اللازمة لتعزيز الصحة البدنية لموظفيهم.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Physical AI readiness is the state of optimal physical health and wellness for employees, encompassing the body's overall health and functionality. It covers various elements such as proper nutrition, regular exercise, adequate sleep, and preventative healthcare. The existing design of the workplace and policies can nudge employees toward or away from their physical AI readiness. Physical AI Readiness assesses the physical safety and health of employees at their workplace. Employees' physical AI readiness is essential for a business's success and productivity because it directly affects their ability to perform their duties effectively and efficiently. <br><br>Additionally, physically well employees are more likely to be engaged and motivated, increasing productivity and job satisfaction. In the long term, investing in the physical AI readiness of employees can also lead to lower healthcare costs and a reduction in absenteeism. Organizations with low score must investigate how their workplace design, policies, and procedures can negatively impact physical AI readiness. For example, poor ergonomics, such as poorly designed desks and chairs, can lead to musculoskeletal problems like back pain, neck pain, and carpal tunnel syndrome. Poor lighting and ventilation can also contribute to physical issues, such as eye strain and headaches. Specific policies and procedures can negatively impact physical AI readiness. A culture that discourages taking breaks can lead to fatigue and burnout. Similarly, a lack of flexibility in the work schedule can cause physical health problems. The organization should be mindful of these factors and make necessary adjustments to promote their employees' physical AI readiness.</p>"
      }
    ]
  },
  {
    "key": "txtDimensionsofWorkplaceWellbeingDesc",
    "text": "The below indicates the scores for each of the [Pillars Count] pillars of Workplace AI Readiness at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يشير ما  يلي إلى الدرجات لكل ركيزة من ركائز جاهزية الذكاء الاصطناعي في الشركة:"
      },
      {
        "language": "EN",
        "text": "The below indicates the scores for each of the [Pillars Count] pillars of Workplace AI Readiness at [Company Name]:"
      }
    ]
  },
  {
    "key": "txtDimensionsOfWorkplaceWellbeing",
    "text": "AI Readiness Pillars ",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Pillars "
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndexpara",
    "text": "The AI Readiness Index indicates the overall AI readiness of respondents in the company. The Data below exhibits the percentage of respondents with very high, high, moderate, low, and very low AI readiness based on their responses to the various pillars of AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "وتمثل مؤشرات جاهزية الذكاء الاصطناعي المستوى التالي من درجة جاهزية الذكاء الاصطناعي في مكان العمل. وتعرض النتائج أدناه النسب المئوية للموظفين الذين يتمتعون بجاهزية الذكاء الاصطناعي مرتفعة للغاية، مرتفعة، معتدلة، منخفضة منخفضة للغاية بناءً على ردودهم على ركائز جاهزية الذكاء الاصطناعي المختارة."
      },
      {
        "language": "EN",
        "text": "The AI Readiness Index indicates the overall AI readiness of respondents in the company. The Data below exhibits the percentage of respondents with very high, high, moderate, low, and very low AI readiness based on their responses to the various pillars of AI Readiness."
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndex",
    "text": "AI Readiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeingpara1",
    "text": "The AI Readiness Score represents the respondents' overall perception of their workplace AI readiness. It is the average score of the respondents to the selected pillars of AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة جاهزية الذكاء الاصطناعي في مكان العمل عن التصور وجاهزية الذكاء الاصطناعي الكلية. وهي تشكل المعدل الكلي لنتائج ركائز جاهزية الذكاء الاصطناعي المختارة."
      },
      {
        "language": "EN",
        "text": "The AI Readiness Score represents the respondents' overall perception of their workplace AI readiness. It is the average score of the respondents to the selected pillars of AI Readiness."
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeing",
    "text": "Overall AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة جاهزية الذكاء الاصطناعي الكلي في مكان العمل"
      },
      {
        "language": "EN",
        "text": "Overall AI Readiness Score"
      }
    ]
  },
  {
    "key": "txtCalculationProcess4",
    "text": "The AI Readiness Index is calculated as per the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن للنتيجة الإجمالية لكل ركيزة مساعدة الشركات على فهم التدابير التي يتعين عليهم اتخاذها لتحسين جاهزية الذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "The AI Readiness Index is calculated as per the received feedback."
      }
    ]
  },
  {
    "key": "txtCalculationProcess3",
    "text": "The Overall AI Readiness Score is calculated as the average rating of the 5 pillars.",
    "translations": [
      {
        "language": "AR",
        "text": "تعطي الدرجة الإجمالية لكل ركيزة متوسط استجابة الموظفين لهذا الركيزة."
      },
      {
        "language": "EN",
        "text": "The Overall AI Readiness Score is calculated as the average rating of the 5 pillars."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "Each pillar score is calculated as the overall rating score of the statements.",
    "translations": [
      {
        "language": "AR",
        "text": "وتعني كلمة \"منخفض للغاية\" أن مكان العمل الحالي والثقافة والممارسات ليست محببة للموظفين، بل وقد تعرض جاهزية الذكاء الاصطناعي للخطر. وفي المقابل، تعني كلمة \"مرتفع للغاية\" أن مكان العمل والثقافة والممارسات الحالية محببة للموظفين بشكل كبير، وأن الشركة تأخذ جاهزية الذكاء الاصطناعي على محمل الجد."
      },
      {
        "language": "EN",
        "text": "Each pillar score is calculated as the overall rating score of the statements."
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "Each statement score is given an average rating based on the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "تتراوح النتيجة الإجمالية لجاهزية الذكاء الاصطناعي في الشركة من منخفض للغاية، منخفض، معتدل، مرتفع إلى مرتفع للغاية."
      },
      {
        "language": "EN",
        "text": "Each statement score is given an average rating based on the received feedback."
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      },
      {
        "language": "EN",
        "text": "Calculation Process"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      },
      {
        "language": "EN",
        "text": "Results Rating"
      }
    ]
  },
  {
    "key": "txtHowtousethisreportpara",
    "text": "txtHowtousethisreportpara",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير درجات جاهزية الذكاء الاصطناعي المعروضة في هذا التقرير إلى الدرجات الإجمالية للموظفين في الشركة.  <br><br> وجدير بالذكر أن الإجراءات الموصى بها لتعزيز جاهزية الذكاء الاصطناعي غير مقتصرة على الاقتراحات المعروضة في هذا التقرير، بل هي أمثلة عن بعض الأنشطة من أصل أنشطة أخرى متعددة والتي من شأنها تعزيز جاهزية الذكاء الاصطناعي في مكان العمل.</p>"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      },
      {
        "language": "EN",
        "text": "How to Use the Report"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensionsPara",
    "text": "<p>Even when the company has good intentions, current workplace practices, policies, and culture sometimes negatively impact employee AI readiness. <br><br>Zenithr's team has designed its AI Readiness based on the industry's latest thought leadership and research. Zenithr's team uses a design thinking approach to help companies prioritize and improve employee AI readiness.<br><br>Improving one pillar can simultaneously improve other pillars. The companies can first prioritize pillars with low scores, as presented in the report.  </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>إن ممارسات وسياسات وثقافة مكان العمل الحالية - حتى عندما يكون لدى المؤسسة نوايا حسنة - تؤثر سلباً في بعض الأحيان على جاهزية الذكاء الاصطناعي. <br><br>وقد قام فريق زينثر بتصور وتصميم جاهزية الذكاء الاصطناعي بناءً على أحدث التطورات والأبحاث الرائدة في هذا المجال. ويستخدم فريق زينثر نهج التفكير التصميمي لمساعدة المؤسسات على إعطاء الأولوية لجاهزية الذكاء الاصطناعي موظفيها وتحسينها باستمرار.<br><br>وجدير بالذكر أنه يمكن لتحسين أحد الركائز أن يؤدي إلى تحسين الركائز الأخرى في ذات الوقت، لذلك يمكن للمؤسسات  البدء بإعطاء الأولوية للركائز ذات الدرجات المنخفضة، كما سيتم ذكره في التقرير.   </p>"
      },
      {
        "language": "EN",
        "text": "<p>Even when the company has good intentions, current workplace practices, policies, and culture sometimes negatively impact employee AI readiness. <br><br>Zenithr's team has designed its AI Readiness based on the industry's latest thought leadership and research. Zenithr's team uses a design thinking approach to help companies prioritize and improve employee AI readiness.<br><br>Improving one pillar can simultaneously improve other pillars. The companies can first prioritize pillars with low scores, as presented in the report.  </p>"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensions",
    "text": "Zenithr AI Readiness Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي الخاصة ب زينثر"
      },
      {
        "language": "EN",
        "text": "Zenithr AI Readiness Pillars"
      }
    ]
  },
  {
    "key": "txtobjectives",
    "text": "<h4 class=\"text-base font-semibold text-zen mt-6\">Objectives of this Report</h4><ol class=\"list-decimal pl-5 mt-2 flex flex-col gap-1\"><li class=\"text-sm text-zen\">Identify the overall level of AI readiness across the organization.</li><li class=\"text-sm text-zen\">Highlight strengths and areas of improvement across the 5 READY pillars.</li><li class=\"text-sm text-zen\">Provide actionable recommendations to accelerate AI adoption.</li></ol>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">أهداف التقرير</h4><div class=\"flex flex-col items-stretch gap-2\"><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تحديد وفهم كيفية إدراك الموظفين لمفهوم جاهزية الذكاء الاصطناعييتهم عبر ركائز مختلفة.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>الحصول على ردود وملاحظات واضحة من الموظفين للحفاظ على جاهزية الذكاء الاصطناعييتهم في مكان العمل ودعمه.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>معالجة مجالات تحسين العمل (بناءً على ركائز ذات درجات منخفضة)</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تقديم توصيات للشركة للحفاظ على جاهزية الذكاء الاصطناعي في العمل وتعزيزها.</p></div></div>"
      },
      {
        "language": "EN",
        "text": "<h4 class=\"text-base font-semibold text-zen mt-6\">Objectives of this Report</h4><ol class=\"list-decimal pl-5 mt-2 flex flex-col gap-1\"><li class=\"text-sm text-zen\">Identify the overall level of AI readiness across the organization.</li><li class=\"text-sm text-zen\">Highlight strengths and areas of improvement across the 5 READY pillars.</li><li class=\"text-sm text-zen\">Provide actionable recommendations to accelerate AI adoption.</li></ol>"
      }
    ]
  },
  {
    "key": "txtIntroductionpara",
    "text": "<p class=\"text-sm text-zen leading-6 italic\">AI Readiness is the extent to which an organization's employees are prepared, willing, and equipped to adopt and leverage Artificial Intelligence in their work. Are they open to AI? Do they feel supported? Do they trust how AI is used?</p><p class=\"text-sm text-zen leading-6 mt-4 italic\">This AI Readiness Survey applies the <strong>READY Model</strong> to measure employees' perceptions of organizational AI readiness, displayed in this report through in-depth analysis, scores, and recommendations.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "تُعرَّف الجاهزية للذكاء الاصطناعي بأنها مدى استعداد موظفي المؤسسة لتبنّي تقنيات الذكاء الاصطناعي واستخدامها بفاعلية في بيئة العمل. وتشمل هذه الجاهزية مدى تقبّل الموظفين للذكاء الاصطناعي، وشعورهم بتوافر الدعم المؤسسي اللازم، ومستوى ثقتهم في آليات تطبيقه واستخدامه داخل المؤسسة. يستند استبيان الجاهزية للذكاء الاصطناعي إلى نموذج READY لقياس تصورات الموظفين حول مستوى جاهزية المؤسسة لتبنّي الذكاء الاصطناعي. ويستعرض هذا التقرير النتائج من خلال تحليل معمّق، ومؤشرات ودرجات تقييم، إلى جانب مجموعة من التوصيات العملية. "
      },
      {
        "language": "EN",
        "text": "<p class=\"text-sm text-zen leading-6 italic\">AI Readiness is the extent to which an organization's employees are prepared, willing, and equipped to adopt and leverage Artificial Intelligence in their work. Are they open to AI? Do they feel supported? Do they trust how AI is used?</p><p class=\"text-sm text-zen leading-6 mt-4 italic\">This AI Readiness Survey applies the <strong>READY Model</strong> to measure employees' perceptions of organizational AI readiness, displayed in this report through in-depth analysis, scores, and recommendations.</p>"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "EN",
        "text": "Introduction"
      }
    ]
  },
  {
    "key": "txtWellbeingReport",
    "text": "AI Readiness  Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness  Report"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "EN",
        "text": "Table of Contents"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "EN",
        "text": "Confidential"
      }
    ]
  },
  {
    "key": "txtEmployeeWellbeing",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "EN",
        "text": "Report"
      }
    ]
  },
  {
    "key": "txt_download_comments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليفات"
      },
      {
        "language": "EN",
        "text": "Download Comments"
      }
    ]
  },
  {
    "key": "txtWorkplaceWellbeingScore",
    "text": "AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي مكان العمل"
      },
      {
        "language": "EN",
        "text": "AI Readiness Score"
      }
    ]
  },
  {
    "key": "txtWellbeingComparison",
    "text": "AI Readiness Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Comparison"
      }
    ]
  },
  {
    "key": "txtSurveysByCompany",
    "text": "Surveys By Company",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيانات حسب الشركة"
      },
      {
        "language": "EN",
        "text": "Surveys By Company"
      }
    ]
  },
  {
    "key": "txtAveraged",
    "text": "Averaged",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "EN",
        "text": "Averaged"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات المختارة"
      },
      {
        "language": "EN",
        "text": "Selected"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "EN",
        "text": "End Date"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "EN",
        "text": "Overall Response Rate"
      }
    ]
  },
  {
    "key": "txtStatusAnalysis",
    "text": "Respondents by Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل حالة المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondents by Status Analysis"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      },
      {
        "language": "EN",
        "text": "Respondents by"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "EN",
        "text": "Mean"
      }
    ]
  },
  {
    "key": "txt_Generated_142",
    "text": "Generated Link",
    "translations": [
      {
        "language": "AR",
        "text": "الرابط المنشئ"
      },
      {
        "language": "EN",
        "text": "Generated Link"
      }
    ]
  },
  {
    "key": "WB:2003",
    "text": "Link has already been sent to the user.",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة الرابط مع المستجيب"
      },
      {
        "language": "EN",
        "text": "Link has already been sent to the user."
      }
    ]
  },
  {
    "key": "txt_remove_criteria_confirmation_message",
    "text": "Are you sure you want to delete this criteria?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذه المعايير؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this criteria?"
      }
    ]
  },
  {
    "key": "txtAnalysisSection",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      },
      {
        "language": "EN",
        "text": "Analysis"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      },
      {
        "language": "EN",
        "text": "High"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "EN",
        "text": "Median"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      },
      {
        "language": "EN",
        "text": "Low"
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      },
      {
        "language": "EN",
        "text": "Heatmap"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      },
      {
        "language": "EN",
        "text": "The value displayed in the cell is delta, which represents a difference in the overall value."
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      },
      {
        "language": "EN",
        "text": "Comparison: Overall"
      }
    ]
  },
  {
    "key": "txtRespondentsBy",
    "text": "Respondents By",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      },
      {
        "language": "EN",
        "text": "Respondents By"
      }
    ]
  },
  {
    "key": "txtByCriteria",
    "text": "By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حسب المعايير"
      },
      {
        "language": "EN",
        "text": "By Criteria"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      },
      {
        "language": "EN",
        "text": "Breakout:"
      }
    ]
  },
  {
    "key": "txtbydimensions",
    "text": "By Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الركائز"
      },
      {
        "language": "EN",
        "text": "By Pillars"
      }
    ]
  },
  {
    "key": "VGOODEXP",
    "text": "Very High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع للغاية"
      },
      {
        "language": "EN",
        "text": "Very High"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع"
      },
      {
        "language": "EN",
        "text": "High"
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      },
      {
        "language": "EN",
        "text": "Moderate"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض"
      },
      {
        "language": "EN",
        "text": "Low"
      }
    ]
  },
  {
    "key": "VPOOREXP",
    "text": "Very Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض للغاية"
      },
      {
        "language": "EN",
        "text": "Very Low"
      }
    ]
  },
  {
    "key": "txtWellbeingIndexByScale",
    "text": "AI Readiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index"
      }
    ]
  },
  {
    "key": "txt_dimensions_score",
    "text": "Pillars Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الركائز"
      },
      {
        "language": "EN",
        "text": "Pillars Score"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "EN",
        "text": "N/A"
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "Global",
    "translations": [
      {
        "language": "AR",
        "text": "العالمي"
      },
      {
        "language": "EN",
        "text": "Global"
      }
    ]
  },
  {
    "key": "txt_TopPerfor_672",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      },
      {
        "language": "EN",
        "text": "Top Performers"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "بشكل عام"
      },
      {
        "language": "EN",
        "text": "Overall"
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      },
      {
        "language": "EN",
        "text": "Benchmarks"
      }
    ]
  },
  {
    "key": "txt_Workplace_Wellbeing_Score",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي مكان العمل"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "EN",
        "text": "Completed"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      },
      {
        "language": "EN",
        "text": "of"
      }
    ]
  },
  {
    "key": "txtExtraDriver",
    "text": "Extra Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "ركيزة جاهزية الذكاء الاصطناعي الإضافي"
      },
      {
        "language": "EN",
        "text": "Extra Pillar"
      }
    ]
  },
  {
    "key": "preparingReport",
    "text": "Preparing Report",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التقرير"
      },
      {
        "language": "EN",
        "text": "Preparing Report"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      },
      {
        "language": "EN",
        "text": "View By"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "EN",
        "text": "Statements"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondent Analysis"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "EN",
        "text": "Overview"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "EN",
        "text": "Back"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message",
    "text": "Are you sure you want to delete this survey?",
    "translations": [
      {
        "language": "AR",
        "text": "هل انت متأكد من حذف هذا الاسبيان؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this survey?"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Survey Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Name"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved\t",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      },
      {
        "language": "EN",
        "text": "All Rights Reserved\t"
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Survey",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الاستبيان"
      },
      {
        "language": "EN",
        "text": "Preview Survey"
      }
    ]
  },
  {
    "key": "txtWellbeingSurveyPreview",
    "text": "AI Readiness Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Survey Preview"
      }
    ]
  },
  {
    "key": "txtRespondentsByStatus",
    "text": "RESPONDENTS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الحالة"
      },
      {
        "language": "EN",
        "text": "RESPONDENTS BY STATUS"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "EN",
        "text": "Response Rate"
      }
    ]
  },
  {
    "key": "txtReminderSent",
    "text": "Reminders has been sent.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التذكيرات."
      },
      {
        "language": "EN",
        "text": "Reminders has been sent."
      }
    ]
  },
  {
    "key": "txt_employee_WellbeingSurvey",
    "text": "AI Readiness Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Survey"
      }
    ]
  },
  {
    "key": "txt_questionnaire_welcome",
    "text": "<p>Thank you for taking the time to fill out the AI Readiness survey. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.<br><br> Disclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>نشكرك لمشاركتك في هذا الاستبيان. أجوبتك النزيهة والصريحة مهمة لنا. يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة. وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.<br><br> إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.</p>"
      },
      {
        "language": "EN",
        "text": "<p>Thank you for taking the time to fill out the AI Readiness survey. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.<br><br> Disclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.</p>"
      }
    ]
  },
  {
    "key": "txt_employee_AiReadinessSurvey",
    "text": "Employee AI Readiness Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان جاهزية الذكاء الاصطناعي للموظف"
      },
      {
        "language": "EN",
        "text": "Employee AI Readiness Survey"
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي للموظف"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txtSendEmails",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال تذكيرات"
      },
      {
        "language": "EN",
        "text": "Send Reminders"
      }
    ]
  },
  {
    "key": "txtProvideEndDate",
    "text": "You need to provide an end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال تاريخ الإكمال."
      },
      {
        "language": "EN",
        "text": "You need to provide an end date."
      }
    ]
  },
  {
    "key": "txt_go_closed",
    "text": "This survey will now be closed and you will no longer be able to make any changes or add new respondents.\t",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا الاستبيان الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      },
      {
        "language": "EN",
        "text": "This survey will now be closed and you will no longer be able to make any changes or add new respondents.\t"
      }
    ]
  },
  {
    "key": "txt_Atleast3r_677",
    "text": "At least 3 respondents should complete the survey in order to close it\t",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      },
      {
        "language": "EN",
        "text": "At least 3 respondents should complete the survey in order to close it\t"
      }
    ]
  },
  {
    "key": "txtRemindersBulkSend",
    "text": "Reminders will be sent to total #count respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إرسال التذكيرات ل #count مستجيب."
      },
      {
        "language": "EN",
        "text": "Reminders will be sent to total #count respondents."
      }
    ]
  },
  {
    "key": "txtSelectAllRespondentsFromPages",
    "text": "Select all respondents from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "اختر  كل المستجيبين من كافة الصفحات؟"
      },
      {
        "language": "EN",
        "text": "Select all respondents from all pages?"
      }
    ]
  },
  {
    "key": "txtSelectedRespondentsOnPage",
    "text": "#count respondents on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار #count مستجيب من هذه الصفحة."
      },
      {
        "language": "EN",
        "text": "#count respondents on this page are selected."
      }
    ]
  },
  {
    "key": "txtAllRespondentsFromPages",
    "text": "All #count respondents from all pages are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count المستجيبين من كافة الصفحات."
      },
      {
        "language": "EN",
        "text": "All #count respondents from all pages are selected."
      }
    ]
  },
  {
    "key": "txtSelectedSurveysOnPage",
    "text": "#count draft surveys on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم #count تحديد مسودة على هذه الصفحة."
      },
      {
        "language": "EN",
        "text": "#count draft surveys on this page are selected."
      }
    ]
  },
  {
    "key": "txtSelectAllFromPages",
    "text": "Select all #count draft surveys from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد تحديد #count  مسودة من كافة الصفحات؟"
      },
      {
        "language": "EN",
        "text": "Select all #count draft surveys from all pages?"
      }
    ]
  },
  {
    "key": "txt_ClearSele_284",
    "text": "Clear Selection",
    "translations": [
      {
        "language": "AR",
        "text": " مسح كافة التحديدات"
      },
      {
        "language": "EN",
        "text": "Clear Selection"
      }
    ]
  },
  {
    "key": "txtAllSurveysSelected",
    "text": "All #count surveys from all pages are selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count الاستبيانات من كافة الصفحات"
      },
      {
        "language": "EN",
        "text": "All #count surveys from all pages are selected. "
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete these respondents?"
      }
    ]
  },
  {
    "key": "txt_ShareSurv_665",
    "text": "Share Survey",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة الاستبيان"
      },
      {
        "language": "EN",
        "text": "Share Survey"
      }
    ]
  },
  {
    "key": "txt_DeleteSel_329",
    "text": "Delete Selected",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Delete Selected"
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondents List"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?\t",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to delete this respondent?\t"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      },
      {
        "language": "EN",
        "text": "Send Reminder"
      }
    ]
  },
  {
    "key": "txt_NewRespon_215",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "EN",
        "text": "Add Respondent"
      }
    ]
  },
  {
    "key": "txt_Share_429",
    "text": "Share",
    "translations": [
      {
        "language": "AR",
        "text": "شارك"
      },
      {
        "language": "EN",
        "text": "Share"
      }
    ]
  },
  {
    "key": "txt_CloseNow_473",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      },
      {
        "language": "EN",
        "text": "Close Now"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      },
      {
        "language": "EN",
        "text": "Live"
      }
    ]
  },
  {
    "key": "txtExport",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Export"
      }
    ]
  },
  {
    "key": "txt_Searchres_762",
    "text": "Search respondents...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث..."
      },
      {
        "language": "EN",
        "text": "Search respondents..."
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      },
      {
        "language": "EN",
        "text": "Multiple Reminders"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.\t",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      },
      {
        "language": "EN",
        "text": "No reminders have been created.\t"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_565",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      },
      {
        "language": "EN",
        "text": "Delete Statement"
      }
    ]
  },
  {
    "key": "txt_delete_item_confirmation_message",
    "text": "Are you sure you want to permanently remove this item?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا العنصر نهائياً؟"
      },
      {
        "language": "EN",
        "text": "Are you sure you want to permanently remove this item?"
      }
    ]
  },
  {
    "key": "txt_NewQuesti_189",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "EN",
        "text": "New Statement"
      }
    ]
  },
  {
    "key": "txt_newstatem_408",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      },
      {
        "language": "EN",
        "text": "New Statement"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Questions"
      }
    ]
  },
  {
    "key": "txt_Selectall_272",
    "text": "Select all",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      },
      {
        "language": "EN",
        "text": "Select all"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      },
      {
        "language": "EN",
        "text": "Generated"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "EN",
        "text": "Powered by:"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      },
      {
        "language": "EN",
        "text": "Close"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Pillar Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الركيزة"
      },
      {
        "language": "EN",
        "text": "Pillar Name"
      }
    ]
  },
  {
    "key": "txt_Atleaston_223",
    "text": "At least one statement needs to be added",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل"
      },
      {
        "language": "EN",
        "text": "At least one statement needs to be added"
      }
    ]
  },
  {
    "key": "txt_Dimension_242",
    "text": "Pillars can't be more than 8",
    "translations": [
      {
        "language": "AR",
        "text": "الركائز يجب ألا تزيد عن 8!"
      },
      {
        "language": "EN",
        "text": "Pillars can't be more than 8"
      }
    ]
  },
  {
    "key": "txt_Dimension_415",
    "text": "At least 3 predefined pillars must be selected!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 ركائز على الأقل!"
      },
      {
        "language": "EN",
        "text": "At least 3 predefined pillars must be selected!"
      }
    ]
  },
  {
    "key": "txt_inthispag_314",
    "text": "in this page have been selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار عناصر في هذه الصفحة"
      },
      {
        "language": "EN",
        "text": "in this page have been selected. "
      }
    ]
  },
  {
    "key": "txt_Allitemsh_336",
    "text": "All items have been selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد كافة العناصر"
      },
      {
        "language": "EN",
        "text": "All items have been selected."
      }
    ]
  },
  {
    "key": "txt_BACKTOSUR_422",
    "text": "BACK",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع"
      },
      {
        "language": "EN",
        "text": "BACK"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال الاستبيان"
      },
      {
        "language": "EN",
        "text": "Invitation Email"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Timeframe"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "EN",
        "text": "Respondents"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      },
      {
        "language": "EN",
        "text": "Analytical Criteria"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Survey Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Setup"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondents",
    "text": "At least 3 respondents are needed to submit the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      },
      {
        "language": "EN",
        "text": "At least 3 respondents are needed to submit the survey."
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      },
      {
        "language": "EN",
        "text": "Added Successfully!"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      },
      {
        "language": "EN",
        "text": "Updated Successfully!"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!\t",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      },
      {
        "language": "EN",
        "text": "Deleted Successfully!\t"
      }
    ]
  },
  {
    "key": "txt_Pleaseimp_478",
    "text": "Please import valid .xlsx file.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى استيراد ملف .xlsx صالح."
      },
      {
        "language": "EN",
        "text": "Please import valid .xlsx file."
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "EN",
        "text": "Cancel"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "EN",
        "text": "Okay"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "EN",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المزيد من التعليقات؟"
      },
      {
        "language": "EN",
        "text": "Have more comments?"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": "I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في بيئة العمل"
      },
      {
        "language": "EN",
        "text": "I feel motivated and inspired at the workplace"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج عرض لسؤال الاستبيان."
      },
      {
        "language": "EN",
        "text": "Question Preview"
      }
    ]
  },
  {
    "key": "txt_Sample_Question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      },
      {
        "language": "EN",
        "text": "Sample Question"
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      },
      {
        "language": "EN",
        "text": "Question Preview"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Survey Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Information"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_862",
    "text": "Add up to 4 statements\t",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 4 عبارات"
      },
      {
        "language": "EN",
        "text": "Add up to 4 statements\t"
      }
    ]
  },
  {
    "key": "txt_NewCustom_150",
    "text": "New Custom Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "بعد مخصص جديد"
      },
      {
        "language": "EN",
        "text": "New Custom Pillar"
      }
    ]
  },
  {
    "key": "txt_STATEMENT_772",
    "text": "Statements of",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات"
      },
      {
        "language": "EN",
        "text": "Statements of"
      }
    ]
  },
  {
    "key": "txt_Selectupt_657",
    "text": "Select up to 8 Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "حدد ما يصل إلى 8 ركائز"
      },
      {
        "language": "EN",
        "text": "Select up to 8 Pillars"
      }
    ]
  },
  {
    "key": "txt_Optional_264",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      },
      {
        "language": "EN",
        "text": "Optional"
      }
    ]
  },
  {
    "key": "txt_Descripti_202",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "txtCustomDimensions",
    "text": "Custom Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Pillars"
      }
    ]
  },
  {
    "key": "txtDimensions",
    "text": "Predefined Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز مُعرفة مسبقاً"
      },
      {
        "language": "EN",
        "text": "Predefined Pillars"
      }
    ]
  },
  {
    "key": "txt_SurveyLis_133",
    "text": " Survey List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الاستبيانات"
      },
      {
        "language": "EN",
        "text": " Survey List"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      },
      {
        "language": "EN",
        "text": "Rename"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "EN",
        "text": "Delete"
      }
    ]
  },
  {
    "key": "txt_NewSetup_163",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      },
      {
        "language": "EN",
        "text": "New Setup"
      }
    ]
  },
  {
    "key": "txt_Search_185",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "EN",
        "text": "Search"
      }
    ]
  },
  {
    "key": "txt_DateCreat_677",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      },
      {
        "language": "EN",
        "text": "Date Created"
      }
    ]
  },
  {
    "key": "txt_SurveyTit_804",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Title"
      }
    ]
  },
  {
    "key": "txt_Status_579",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "EN",
        "text": "Status"
      }
    ]
  },
  {
    "key": "txt_Workplace_928",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي مكان العمل"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الجميع"
      },
      {
        "language": "EN",
        "text": "All"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "EN",
        "text": "Previous"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      },
      {
        "language": "EN",
        "text": "Send Invitations"
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      },
      {
        "language": "EN",
        "text": "Add Respondent"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Set Timeframe"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "EN",
        "text": "Start Date"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      },
      {
        "language": "EN",
        "text": "Completion Date"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      },
      {
        "language": "EN",
        "text": "Set Reminders"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "EN",
        "text": "Add Reminder"
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      },
      {
        "language": "EN",
        "text": "Reminder Date"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة الاستبيان قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      },
      {
        "language": "EN",
        "text": "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      },
      {
        "language": "EN",
        "text": "Reminder Template"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      },
      {
        "language": "EN",
        "text": "Email Template"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الاستبيان"
      },
      {
        "language": "EN",
        "text": "Edit Survey"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Title"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "EN",
        "text": "Update"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      },
      {
        "language": "EN",
        "text": "Send Reminders"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      },
      {
        "language": "EN",
        "text": "Save Template"
      }
    ]
  },
  {
    "key": "NOTREADY",
    "text": "Not Ready",
    "translations": [
      {
        "language": "AR",
        "text": "غير جاهز"
      },
      {
        "language": "EN",
        "text": "Not Ready"
      }
    ]
  },
  {
    "key": "DEVELOPING",
    "text": "Planning",
    "translations": [
      {
        "language": "AR",
        "text": "قيد التخطيط"
      },
      {
        "language": "EN",
        "text": "Planning"
      }
    ]
  },
  {
    "key": "READY",
    "text": "Developing",
    "translations": [
      {
        "language": "AR",
        "text": "قيد التطوير"
      },
      {
        "language": "EN",
        "text": "Developing"
      }
    ]
  },
  {
    "key": "HIGHLYREADY",
    "text": "Ready",
    "translations": [
      {
        "language": "AR",
        "text": "جاهز"
      },
      {
        "language": "EN",
        "text": "Ready"
      }
    ]
  },
  {
    "key": "txtAiReadiness",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness"
      }
    ]
  },
  {
    "key": "txtReceptivenessDescription",
    "text": "Employee receptiveness reflects the emotional and psychological foundation for AI adoption. It captures how open, optimistic, and enthusiastic employees are toward AI, as well as the extent to which they are free from anxiety or fear about its impact on their roles. When workers feel secure and engaged, organizations are much more likely to achieve successful, lasting AI integration. Strengthening receptiveness is therefore a prerequisite: without it, even the most sophisticated tools and expertly crafted training programs will not lead to meaningful adoption. By fostering a positive environment, organizations can inspire confidence and enthusiasm for AI, paving the way for innovation and shared growth.",
    "translations": [
      {
        "language": "AR",
        "text": "يعكس تقبّل الموظفين الأساس العاطفي والنفسي لتبنّي الذكاء الاصطناعي. ويقيس مدى انفتاح الموظفين وتفاؤلهم وحماسهم تجاه الذكاء الاصطناعي، بالإضافة إلى مدى تحررهم من القلق أو الخوف بشأن تأثيره في أدوارهم الوظيفية. عندما يشعر الموظفون بالأمان والمشاركة، تزداد قدرة المؤسسات بصورة كبيرة على تحقيق دمج ناجح ومستدام للذكاء الاصطناعي. لذلك، يُعد تعزيز التقبّل متطلبًا أساسيًا؛ فمن دونه، لن تؤدي حتى أكثر الأدوات تطورًا وبرامج التدريب المصممة باحترافية إلى تبنٍّ فعلي وهادف. ومن خلال توفير بيئة إيجابية، يمكن للمؤسسات تعزيز الثقة والحماس تجاه الذكاء الاصطناعي، بما يمهّد الطريق للابتكار والنمو المشترك."
      },
      {
        "language": "EN",
        "text": "Employee receptiveness reflects the emotional and psychological foundation for AI adoption. It captures how open, optimistic, and enthusiastic employees are toward AI, as well as the extent to which they are free from anxiety or fear about its impact on their roles. When workers feel secure and engaged, organizations are much more likely to achieve successful, lasting AI integration. Strengthening receptiveness is therefore a prerequisite: without it, even the most sophisticated tools and expertly crafted training programs will not lead to meaningful adoption. By fostering a positive environment, organizations can inspire confidence and enthusiasm for AI, paving the way for innovation and shared growth."
      }
    ]
  },
  {
    "key": "txtReceptivenessRecomendations1",
    "text": "Host leadership-led town halls and open forums to address AI-related concerns and share internal success stories.",
    "translations": [
      {
        "language": "AR",
        "text": "تنظيم لقاءات عامة ومنتديات مفتوحة بقيادة الإدارة لمناقشة المخاوف المرتبطة بالذكاء الاصطناعي ومشاركة قصص النجاح الداخلية."
      },
      {
        "language": "EN",
        "text": "Host leadership-led town halls and open forums to address AI-related concerns and share internal success stories."
      }
    ]
  },
  {
    "key": "txtReceptivenessRecomendations2",
    "text": "Launch an internal “AI Champions” program to identify early adopters and empower them to share their positive experiences with peers.",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق برنامج داخلي لـ «سفراء الذكاء الاصطناعي» بهدف تحديد الموظفين المبادرين إلى تبنّي التقنية وتمكينهم من مشاركة تجاربهم الإيجابية مع زملائهم."
      },
      {
        "language": "EN",
        "text": "Launch an internal “AI Champions” program to identify early adopters and empower them to share their positive experiences with peers."
      }
    ]
  },
  {
    "key": "txtReceptivenessRecomendations3",
    "text": "Communicate clearly, using department-specific examples, that AI is intended to augment roles rather than replace them.",
    "translations": [
      {
        "language": "AR",
        "text": "توضيح أن الهدف من الذكاء الاصطناعي هو دعم الأدوار الوظيفية وتعزيزها، وليس استبدالها، مع استخدام أمثلة واضحة ومخصصة لكل إدارة أو قسم."
      },
      {
        "language": "EN",
        "text": "Communicate clearly, using department-specific examples, that AI is intended to augment roles rather than replace them."
      }
    ]
  },
  {
    "key": "txtReceptivenessRecomendations4",
    "text": "Create safe AI “sandbox” environments where employees can explore AI tools without fear of making mistakes.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء بيئات تجريبية آمنة للذكاء الاصطناعي تتيح للموظفين استكشاف الأدوات وتجربتها دون الخوف من ارتكاب الأخطاء."
      },
      {
        "language": "EN",
        "text": "Create safe AI “sandbox” environments where employees can explore AI tools without fear of making mistakes."
      }
    ]
  },
  {
    "key": "txtEnablementDescription",
    "text": "Enablement ensures that employees are equipped with the necessary training, skills, and organizational support to harness AI’s potential for real performance improvements. When employees have access to ongoing, relevant learning opportunities and feel confident that their skills align with AI advancements, adoption happens seamlessly. However, without adequate enablement, even the most eager employees may find it challenging to integrate AI into their daily workflows. This pillar is a key driver for successful AI readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "يضمن التمكين تزويد الموظفين بالتدريب والمهارات والدعم المؤسسي اللازم للاستفادة من إمكانات الذكاء الاصطناعي وتحويلها إلى تحسينات فعلية في الأداء. عندما تتاح للموظفين فرص تعلّم مستمرة وملائمة، ويشعرون بالثقة في أن مهاراتهم تتوافق مع تطورات الذكاء الاصطناعي، تتم عملية التبنّي بسلاسة. وفي المقابل، قد يجد حتى أكثر الموظفين حماسًا صعوبة في دمج الذكاء الاصطناعي في مهامهم اليومية عند غياب التمكين الكافي. لذلك، يمثل هذا المحور قوة أساسية ومحركة لتحقيق الجاهزية الناجحة للذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "Enablement ensures that employees are equipped with the necessary training, skills, and organizational support to harness AI’s potential for real performance improvements. When employees have access to ongoing, relevant learning opportunities and feel confident that their skills align with AI advancements, adoption happens seamlessly. However, without adequate enablement, even the most eager employees may find it challenging to integrate AI into their daily workflows. This pillar is a key driver for successful AI readiness."
      }
    ]
  },
  {
    "key": "txtEnablementRecomendations1",
    "text": "Develop a structured AI learning path with tiered levels—awareness, application, and advanced—tailored to different roles and departments.",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير مسار تعلّم منظم للذكاء الاصطناعي يتضمن مستويات متدرجة، مثل الوعي والتطبيق والمستوى المتقدم، على أن يكون مصممًا بما يتناسب مع الأدوار الوظيفية والإدارات المختلفة."
      },
      {
        "language": "EN",
        "text": "Develop a structured AI learning path with tiered levels—awareness, application, and advanced—tailored to different roles and departments."
      }
    ]
  },
  {
    "key": "txtEnablementRecomendations2",
    "text": "Offer regular, accessible training sessions that evolve continuously rather than following an annual cycle.",
    "translations": [
      {
        "language": "AR",
        "text": "تقديم جلسات تدريبية منتظمة وسهلة الوصول، يتم تطويرها وتحديثها باستمرار بدلًا من الاعتماد على دورة تدريبية سنوية فقط."
      },
      {
        "language": "EN",
        "text": "Offer regular, accessible training sessions that evolve continuously rather than following an annual cycle."
      }
    ]
  },
  {
    "key": "txtEnablementRecomendations3",
    "text": "Pair employees with AI learning mentors or “buddies” to provide hands-on, ongoing support.",
    "translations": [
      {
        "language": "AR",
        "text": "ربط الموظفين بمرشدين أو زملاء داعمين لتعلّم الذكاء الاصطناعي، لتوفير المساندة العملية والمستمرة أثناء التعلّم والتطبيق. "
      },
      {
        "language": "EN",
        "text": "Pair employees with AI learning mentors or “buddies” to provide hands-on, ongoing support."
      }
    ]
  },
  {
    "key": "txtEnablementRecomendations4",
    "text": "Allocate dedicated time within work schedules for employees to learn and practice AI skills without affecting their performance expectations.",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص وقت محدد ضمن جداول العمل لتمكين الموظفين من تعلّم مهارات الذكاء الاصطناعي وممارستها دون التأثير سلبًا في توقعات الأداء المطلوبة منهم."
      },
      {
        "language": "EN",
        "text": "Allocate dedicated time within work schedules for employees to learn and practice AI skills without affecting their performance expectations."
      }
    ]
  },
  {
    "key": "txtAssuranceDescription",
    "text": "Assurance is essential for successful AI adoption, reflecting employees’ trust that AI is used ethically and responsibly in alignment with the organization’s core values. This includes confidence in data privacy, clear governance guidelines, and the belief that AI-driven decisions are fair and transparent. Because trust is fragile, even a single breach can hinder progress. Maintaining assurance is therefore vital and requires continuous, visible support to create an environment in which innovation can thrive.",
    "translations": [
      {
        "language": "AR",
        "text": "عدّ الثقة عنصرًا أساسيًا لنجاح تبنّي الذكاء الاصطناعي، إذ تعكس مدى ثقة الموظفين في استخدامه بصورة أخلاقية ومسؤولة وبما يتوافق مع القيم الأساسية للمؤسسة. ويشمل ذلك الثقة في خصوصية البيانات، ووضوح إرشادات الحوكمة، والاعتقاد بأن القرارات المدعومة بالذكاء الاصطناعي تتسم بالعدالة والشفافية. ونظرًا إلى هشاشة الثقة، فقد تؤدي حتى مخالفة واحدة إلى عرقلة التقدم. لذلك، يُعد الحفاظ على الثقة أمرًا بالغ الأهمية، ويتطلب دعمًا مستمرًا وواضحًا لتهيئة بيئة مزدهرة للابتكار."
      },
      {
        "language": "EN",
        "text": "Assurance is essential for successful AI adoption, reflecting employees’ trust that AI is used ethically and responsibly in alignment with the organization’s core values. This includes confidence in data privacy, clear governance guidelines, and the belief that AI-driven decisions are fair and transparent. Because trust is fragile, even a single breach can hinder progress. Maintaining assurance is therefore vital and requires continuous, visible support to create an environment in which innovation can thrive."
      }
    ]
  },
  {
    "key": "txtAssuranceRecomendations1",
    "text": "Publish and communicate a clear AI ethics policy that outlines how data is used, protected, and governed within the organization.",
    "translations": [
      {
        "language": "AR",
        "text": "نشر سياسة واضحة لأخلاقيات الذكاء الاصطناعي والتعريف بها، توضح كيفية استخدام البيانات وحمايتها وحوكمتها داخل المؤسسة."
      },
      {
        "language": "EN",
        "text": "Publish and communicate a clear AI ethics policy that outlines how data is used, protected, and governed within the organization."
      }
    ]
  },
  {
    "key": "txtAssuranceRecomendations2",
    "text": "Establish a visible AI governance committee and communicate its role in ensuring responsible AI use to all employees.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء لجنة واضحة وفاعلة لحوكمة الذكاء الاصطناعي، وتعريف جميع الموظفين بدورها في ضمان الاستخدام المسؤول للذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "Establish a visible AI governance committee and communicate its role in ensuring responsible AI use to all employees."
      }
    ]
  },
  {
    "key": "txtAssuranceRecomendations3",
    "text": "Provide transparency on how AI tools make decisions that affect employees' work, performance, or career progression.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الشفافية بشأن كيفية اتخاذ أدوات الذكاء الاصطناعي للقرارات التي تؤثر في أعمال الموظفين أو أدائهم أو تطورهم المهني."
      },
      {
        "language": "EN",
        "text": "Provide transparency on how AI tools make decisions that affect employees' work, performance, or career progression."
      }
    ]
  },
  {
    "key": "txtAssuranceRecomendations4",
    "text": "Conduct regular AI audits and share summarized findings with employees to reinforce accountability and build confidence.",
    "translations": [
      {
        "language": "AR",
        "text": "إجراء عمليات تدقيق منتظمة للذكاء الاصطناعي ومشاركة ملخص النتائج مع الموظفين لتعزيز المساءلة وبناء الثقة."
      },
      {
        "language": "EN",
        "text": "Conduct regular AI audits and share summarized findings with employees to reinforce accountability and build confidence."
      }
    ]
  },
  {
    "key": "txtDirectionDescription",
    "text": "Effective direction is essential for strong leadership communication and a shared vision for AI adoption. When leaders clearly connect AI initiatives to strategic goals and managers support their teams throughout these changes, employees feel empowered and confident. Clear guidance enables even the most enthusiastic and skilled employees to thrive by turning uncertainty into action and clarifying their roles.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعد التوجيه الفعّال عنصرًا أساسيًا لتعزيز التواصل القيادي وبناء رؤية مشتركة لتبنّي الذكاء الاصطناعي. فعندما يربط القادة بوضوح مبادرات الذكاء الاصطناعي بالأهداف الاستراتيجية، ويدعم المديرون فرقهم خلال مراحل التغيير، يشعر الموظفون بالتمكين والثقة. كما يساعد التوجيه الواضح حتى أكثر الموظفين حماسًا ومهارة على النجاح، من خلال تحويل حالة عدم اليقين إلى خطوات عملية وتوضيح أدوارهم ومسؤولياتهم."
      },
      {
        "language": "EN",
        "text": "Effective direction is essential for strong leadership communication and a shared vision for AI adoption. When leaders clearly connect AI initiatives to strategic goals and managers support their teams throughout these changes, employees feel empowered and confident. Clear guidance enables even the most enthusiastic and skilled employees to thrive by turning uncertainty into action and clarifying their roles."
      }
    ]
  },
  {
    "key": "txtDirectionRecomendations1",
    "text": "Develop and communicate a clear AI vision statement that connects AI adoption to the organization's strategic goals and employees' daily work.",
    "translations": [
      {
        "language": "AR",
        "text": "تطوير بيان رؤية واضح للذكاء الاصطناعي والتعريف به، يربط تبني الذكاء الاصطناعي بالأهداف الاستراتيجية للمؤسسة وبالعمل اليومي للموظفين."
      },
      {
        "language": "EN",
        "text": "Develop and communicate a clear AI vision statement that connects AI adoption to the organization's strategic goals and employees' daily work."
      }
    ]
  },
  {
    "key": "txtDirectionRecomendations2",
    "text": "Equip managers with AI communication toolkits so they can confidently discuss AI plans, answer questions, and guide their teams.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء قنوات تواصل منتظمة لتقديم تحديثات الذكاء الاصطناعي، مثل النشرات الدورية والإحاطات، لضمان إطلاع جميع المستويات التنظيمية على التقدم والخطط والمحطات الرئيسية."
      },
      {
        "language": "EN",
        "text": "Equip managers with AI communication toolkits so they can confidently discuss AI plans, answer questions, and guide their teams."
      }
    ]
  },
  {
    "key": "txtDirectionRecomendations3",
    "text": "Establish regular AI update communications, such as newsletters and briefings, to keep all organizational levels informed about progress, plans, and milestones.",
    "translations": [
      {
        "language": "AR",
        "text": "نشاء قنوات تواصل منتظمة لتقديم تحديثات الذكاء الاصطناعي، مثل النشرات الدورية والإحاطات، لضمان إطلاع جميع المستويات التنظيمية على التقدم والخطط والمحطات الرئيسية."
      },
      {
        "language": "EN",
        "text": "Establish regular AI update communications, such as newsletters and briefings, to keep all organizational levels informed about progress, plans, and milestones."
      }
    ]
  },
  {
    "key": "txtDirectionRecomendations4",
    "text": "Embed AI adoption goals within leadership KPIs to reinforce accountability for driving the agenda.",
    "translations": [
      {
        "language": "AR",
        "text": "إدراج أهداف تبنّي الذكاء الاصطناعي ضمن مؤشرات الأداء الرئيسية للقيادات، لتعزيز المساءلة عن تنفيذ التوجه ودفعه إلى الأمام."
      },
      {
        "language": "EN",
        "text": "Embed AI adoption goals within leadership KPIs to reinforce accountability for driving the agenda."
      }
    ]
  },
  {
    "key": "txtYieldDescription",
    "text": "Yield is a powerful indicator of an organization’s readiness to embrace AI, as it reflects employees’ genuine belief in its ability to improve their work. When employees experience tangible benefits—such as increased efficiency, fewer repetitive tasks, and higher-quality outputs—their confidence in AI grows, leading to more enthusiastic adoption. Organizations are more likely to realize the value of their AI investments when employees actively experience the benefits of these tools in their daily work.",
    "translations": [
      {
        "language": "AR",
        "text": "يُعد العائد مؤشرًا قويًا على مدى جاهزية المؤسسة لتبنّي الذكاء الاصطناعي، إذ يعكس إيمان الموظفين الحقيقي بقدرته على تحسين أعمالهم. فعندما يلمس الموظفون فوائد ملموسة، مثل زيادة الكفاءة، وتقليل المهام المتكررة، وتحسين جودة المخرجات، تنمو ثقتهم في الذكاء الاصطناعي، مما يؤدي إلى تبنّيه بحماس أكبر. وتزداد فرص المؤسسات في تحقيق العائد المرجو من استثماراتها في الذكاء الاصطناعي عندما يشعر الموظفون فعليًا بقيمة هذه الأدوات في أعمالهم اليومية."
      },
      {
        "language": "EN",
        "text": "Yield is a powerful indicator of an organization’s readiness to embrace AI, as it reflects employees’ genuine belief in its ability to improve their work. When employees experience tangible benefits—such as increased efficiency, fewer repetitive tasks, and higher-quality outputs—their confidence in AI grows, leading to more enthusiastic adoption. Organizations are more likely to realize the value of their AI investments when employees actively experience the benefits of these tools in their daily work."
      }
    ]
  },
  {
    "key": "txtYieldRecomendations1",
    "text": "Identify and communicate quick-win AI use cases within each department that demonstrate immediate, visible impact on daily workflows.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد حالات استخدام الذكاء الاصطناعي سريعة الأثر ضمن كل إدارة والتعريف بها، بحيث تُظهر تأثيراً فورياً وملموساً على سير العمل اليومي."
      },
      {
        "language": "EN",
        "text": "Identify and communicate quick-win AI use cases within each department that demonstrate immediate, visible impact on daily workflows."
      }
    ]
  },
  {
    "key": "txtYieldRecomendations2",
    "text": "Collect and share employee testimonials and metrics that showcase how AI tools have saved time or improved output quality.",
    "translations": [
      {
        "language": "AR",
        "text": "جمع ومشاركة شهادات الموظفين والمقاييس التي تُبرز كيف وفّرت أدوات الذكاء الاصطناعي الوقت أو حسّنت جودة المخرجات."
      },
      {
        "language": "EN",
        "text": "Collect and share employee testimonials and metrics that showcase how AI tools have saved time or improved output quality."
      }
    ]
  },
  {
    "key": "txtYieldRecomendations3",
    "text": "Ensure AI tools are user-friendly and well-integrated into existing workflows rather than adding complexity or extra steps.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من أن أدوات الذكاء الاصطناعي سهلة الاستخدام ومتكاملة بصورة جيدة مع إجراءات العمل الحالية، بدلًا من أن تضيف مزيدًا من التعقيد أو الخطوات الإضافية."
      },
      {
        "language": "EN",
        "text": "Ensure AI tools are user-friendly and well-integrated into existing workflows rather than adding complexity or extra steps."
      }
    ]
  },
  {
    "key": "txtYieldRecomendations4",
    "text": "Establish feedback loops where employees can report AI tool issues and see improvements implemented based on their input.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء قنوات تغذية راجعة تتيح للموظفين الإبلاغ عن المشكلات المتعلقة بأدوات الذكاء الاصطناعي، ومتابعة التحسينات التي يتم تنفيذها بناءً على ملاحظاتهم ومقترحاتهم. "
      },
      {
        "language": "EN",
        "text": "Establish feedback loops where employees can report AI tool issues and see improvements implemented based on their input."
      }
    ]
  },
  {
    "key": "txt_Export_229",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تصدير"
      },
      {
        "language": "EN",
        "text": "Export"
      }
    ]
  },
  {
    "key": "txt_RawData_453",
    "text": "Raw Data",
    "translations": [
      {
        "language": "AR",
        "text": "البيانات الأولية"
      },
      {
        "language": "EN",
        "text": "Raw Data"
      }
    ]
  },
  {
    "key": "txt_Workplace_AiReadiness_Score",
    "text": "AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Score"
      }
    ]
  },
  {
    "key": "txtAiReadinessIndexByScale",
    "text": "AI Readiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index"
      }
    ]
  },
  {
    "key": "txtAiReadinessIndexByDimension",
    "text": "AI Readiness Index by Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي حسب الركيزة"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index by Pillar"
      }
    ]
  },
  {
    "key": "txtByPillars",
    "text": "By Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الركائز"
      },
      {
        "language": "EN",
        "text": "By Pillars"
      }
    ]
  },
  {
    "key": "txt_By_784",
    "text": "By",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      },
      {
        "language": "EN",
        "text": "By"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceAiReadiness",
    "text": "Overall AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الإجمالية لجاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "Overall AI Readiness Score"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceAiReadinesspara1",
    "text": "The AI Readiness Score represents respondents' overall perception of how ready their organization is for AI. Scores are calculated on a 4-point agreement scale, converted to a 0–100% range, and classified into four readiness levels.",
    "translations": [
      {
        "language": "AR",
        "text": "تمثل درجة جاهزية الذكاء الاصطناعي الإدراك العام للمستجيبين حول مدى استعداد مؤسستهم للذكاء الاصطناعي. يتم احتساب الدرجات على مقياس اتفاق رباعي، تُحوَّل إلى نطاق 0-100٪، وتُصنَّف ضمن أربعة مستويات للجاهزية."
      },
      {
        "language": "EN",
        "text": "The AI Readiness Score represents respondents' overall perception of how ready their organization is for AI. Scores are calculated on a 4-point agreement scale, converted to a 0–100% range, and classified into four readiness levels."
      }
    ]
  },
  {
    "key": "txtEmployeesAiReadinessIndex",
    "text": "AI Readiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Index"
      }
    ]
  },
  {
    "key": "txtEmployeesAiReadinessIndexpara",
    "text": "The AI Readiness Index shows the distribution of employees across the four readiness levels at [Company Name], illustrating how prepared your workforce is for AI adoption.",
    "translations": [
      {
        "language": "AR",
        "text": "يُظهر مؤشر جاهزية الذكاء الاصطناعي توزيع الموظفين عبر مستويات الجاهزية الأربعة في [Company Name]، ويوضح مدى استعداد القوى العاملة لتبني الذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "The AI Readiness Index shows the distribution of employees across the four readiness levels at [Company Name], illustrating how prepared your workforce is for AI adoption."
      }
    ]
  },
  {
    "key": "txtDimensionsOfWorkplaceAiReadiness",
    "text": "AI Readiness Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Pillars"
      }
    ]
  },
  {
    "key": "txtDimensionsofWorkplaceAiReadinessDesc",
    "text": "The following indicates the scores for each of the [Dimensions Count] pillars of AI Readiness at [Company Name].",
    "translations": [
      {
        "language": "AR",
        "text": "يشير ما يلي إلى الدرجات لكل ركيزة من ركائز جاهزية الذكاء الاصطناعي الـ [Dimensions Count] في [Company Name]."
      },
      {
        "language": "EN",
        "text": "The following indicates the scores for each of the [Dimensions Count] pillars of AI Readiness at [Company Name]."
      }
    ]
  },
  {
    "key": "txtZenAiReadinessDimensions",
    "text": "Zenithr AI Readiness Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي من زينثر"
      },
      {
        "language": "EN",
        "text": "Zenithr AI Readiness Pillars"
      }
    ]
  },
  {
    "key": "txtZenAiReadinessDimensionsPara",
    "text": "Even when an organization has good intentions, current workplace practices, policies, and culture may hinder employees from feeling open, supported, and aligned with AI adoption. The READY Model measures employee perception across five interconnected pillars.",
    "translations": [
      {
        "language": "AR",
        "text": "حتى عندما يكون لدى المؤسسة نوايا حسنة، قد تعيق الممارسات والسياسات والثقافة الحالية في مكان العمل شعور الموظفين بالانفتاح والدعم والتوافق مع تبني الذكاء الاصطناعي. يقيس نموذج READY تصور الموظفين عبر خمس ركائز مترابطة."
      },
      {
        "language": "EN",
        "text": "Even when an organization has good intentions, current workplace practices, policies, and culture may hinder employees from feeling open, supported, and aligned with AI adoption. The READY Model measures employee perception across five interconnected pillars."
      }
    ]
  },
  {
    "key": "txtExportCommentCheckbox",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "EN",
        "text": "Comments"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments export is not available for this module",
    "translations": [
      {
        "language": "AR",
        "text": "تصدير التعليقات غير متاح لهذه الوحدة"
      },
      {
        "language": "EN",
        "text": "Comments export is not available for this module"
      }
    ]
  },
  {
    "key": "txtjoinersAnalysis",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبين"
      },
      {
        "language": "EN",
        "text": "Respondent Analysis"
      }
    ]
  },
  {
    "key": "txtEmployeeAiReadiness",
    "text": "AI READINESS",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI READINESS"
      }
    ]
  },
  {
    "key": "txtAiReadinessReport",
    "text": "AI READINESS REPORT",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI READINESS REPORT"
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceAiReadiness",
    "text": "AI Readiness Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "ركائز جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Pillars"
      }
    ]
  },
  {
    "key": "txtWokplaceAiReadinessEx",
    "text": "AI Readiness by",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي حسب"
      },
      {
        "language": "EN",
        "text": "AI Readiness by"
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "EN",
        "text": "For"
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared for",
    "translations": [
      {
        "language": "AR",
        "text": "مُعدّ لـ"
      },
      {
        "language": "EN",
        "text": "Prepared for"
      }
    ]
  },
  {
    "key": "txtAiExecutiveSummary",
    "text": "AI Executive Summary",
    "translations": [
      {
        "language": "AR",
        "text": "الملخص التنفيذي للذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Executive Summary"
      }
    ]
  },
  {
    "key": "txtAiExecutiveSummary_desc",
    "text": "Generate an AI-powered narrative summarising your READY results — overall score, pillar insights and top strategic priorities.",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ ملخصاً مدعوماً بالذكاء الاصطناعي يلخّص نتائج READY — النتيجة الإجمالية ورؤى الركائز وأبرز الأولويات الاستراتيجية."
      },
      {
        "language": "EN",
        "text": "Generate an AI-powered narrative summarising your READY results — overall score, pillar insights and top strategic priorities."
      }
    ]
  },
  {
    "key": "txtGenerateSummary",
    "text": "Generate Summary",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء الملخص"
      },
      {
        "language": "EN",
        "text": "Generate Summary"
      }
    ]
  },
  {
    "key": "txtRegenerateSummary",
    "text": "Regenerate",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة الإنشاء"
      },
      {
        "language": "EN",
        "text": "Regenerate"
      }
    ]
  },
  {
    "key": "txtSummaryLoading",
    "text": "Analysing your ready results…",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحليل نتائج جاهزية الذكاء الاصطناعي للموظفين…"
      },
      {
        "language": "EN",
        "text": "Analysing your ready results…"
      }
    ]
  },
  {
    "key": "txtSummaryError",
    "text": "Failed to generate the summary. Please try again.",
    "translations": [
      {
        "language": "AR",
        "text": "فشل إنشاء الملخص. يرجى المحاولة مرة أخرى."
      },
      {
        "language": "EN",
        "text": "Failed to generate the summary. Please try again."
      }
    ]
  },
  {
    "key": "txtOverallAssessment",
    "text": "Overall Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم العام"
      },
      {
        "language": "EN",
        "text": "Overall Assessment"
      }
    ]
  },
  {
    "key": "txtPillarInsights",
    "text": "Pillar Insights",
    "translations": [
      {
        "language": "AR",
        "text": "رؤى الركائز"
      },
      {
        "language": "EN",
        "text": "Pillar Insights"
      }
    ]
  },
  {
    "key": "txtStrategicPriorities",
    "text": "Top Strategic Priorities",
    "translations": [
      {
        "language": "AR",
        "text": "أبرز الأولويات الاستراتيجية"
      },
      {
        "language": "EN",
        "text": "Top Strategic Priorities"
      }
    ]
  },
  {
    "key": "txtCopySummary",
    "text": "Copy",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ"
      },
      {
        "language": "EN",
        "text": "Copy"
      }
    ]
  },
  {
    "key": "txtFiltersChangedWarning",
    "text": "Filters changed since last generation.",
    "translations": [
      {
        "language": "AR",
        "text": "تغيّرت الفلاتر منذ آخر إنشاء للملخص."
      },
      {
        "language": "EN",
        "text": "Filters changed since last generation."
      }
    ]
  },
  {
    "key": "txtAiReadinessDefinition1",
    "text": "AI Readiness is the extent to which an organization's employees are prepared, willing, and equipped to adopt and leverage Artificial Intelligence in their work. Are they open to AI? Do they feel supported? Do they trust how AI is used?",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي هي المدى الذي يكون فيه موظفو المؤسسة مستعدين وراغبين ومؤهلين لتبني الذكاء الاصطناعي والاستفادة منه في عملهم. هل هم منفتحون على الذكاء الاصطناعي؟ هل يشعرون بالدعم؟ هل يثقون في كيفية استخدامه؟"
      },
      {
        "language": "EN",
        "text": "AI Readiness is the extent to which an organization's employees are prepared, willing, and equipped to adopt and leverage Artificial Intelligence in their work. Are they open to AI? Do they feel supported? Do they trust how AI is used?"
      }
    ]
  },
  {
    "key": "txtAiReadinessDefinition2",
    "text": "This AI Readiness Survey applies the READY Model to measure employees' perceptions of organizational AI readiness, displayed in this report through in-depth analysis, scores, and recommendations.",
    "translations": [
      {
        "language": "AR",
        "text": "يطبّق هذا الاستطلاع نموذج READY لقياس تصورات الموظفين حول جاهزية المؤسسة للذكاء الاصطناعي، ويعرض ذلك في هذا التقرير من خلال تحليل معمّق ودرجات وتوصيات."
      },
      {
        "language": "EN",
        "text": "This AI Readiness Survey applies the READY Model to measure employees' perceptions of organizational AI readiness, displayed in this report through in-depth analysis, scores, and recommendations."
      }
    ]
  },
  {
    "key": "txtObjectivesTitle",
    "text": "Objectives of this Report",
    "translations": [
      {
        "language": "AR",
        "text": "أهداف هذا التقرير"
      },
      {
        "language": "EN",
        "text": "Objectives of this Report"
      }
    ]
  },
  {
    "key": "txtObjective1",
    "text": "Identify the overall level of AI readiness across the organization.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد المستوى العام لجاهزية الذكاء الاصطناعي في المؤسسة."
      },
      {
        "language": "EN",
        "text": "Identify the overall level of AI readiness across the organization."
      }
    ]
  },
  {
    "key": "txtObjective2",
    "text": "Highlight strengths and areas of improvement across the 5 READY pillars.",
    "translations": [
      {
        "language": "AR",
        "text": "إبراز نقاط القوة ومجالات التحسين عبر الركائز الخمس لنموذج READY."
      },
      {
        "language": "EN",
        "text": "Highlight strengths and areas of improvement across the 5 READY pillars."
      }
    ]
  },
  {
    "key": "txtObjective3",
    "text": "Provide actionable recommendations to accelerate AI adoption.",
    "translations": [
      {
        "language": "AR",
        "text": "تقديم توصيات عملية لتسريع تبني الذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "Provide actionable recommendations to accelerate AI adoption."
      }
    ]
  },
  {
    "key": "txtViewSummary",
    "text": "View Summary",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الملخص"
      },
      {
        "language": "EN",
        "text": "View Summary"
      }
    ]
  },
  {
    "key": "txtStrength",
    "text": "Strength",
    "translations": [
      {
        "language": "AR",
        "text": "نقطة قوة"
      },
      {
        "language": "EN",
        "text": "Strength"
      }
    ]
  },
  {
    "key": "txtGap",
    "text": "Gap",
    "translations": [
      {
        "language": "AR",
        "text": "فجوة"
      },
      {
        "language": "EN",
        "text": "Gap"
      }
    ]
  },
  {
    "key": "txtDecision",
    "text": "Decision",
    "translations": [
      {
        "language": "AR",
        "text": "القرار"
      },
      {
        "language": "EN",
        "text": "Decision"
      }
    ]
  },
  {
    "key": "txtWhy",
    "text": "Why",
    "translations": [
      {
        "language": "AR",
        "text": "لماذا"
      },
      {
        "language": "EN",
        "text": "Why"
      }
    ]
  },
  {
    "key": "txtImpact",
    "text": "Impact",
    "translations": [
      {
        "language": "AR",
        "text": "الأثر"
      },
      {
        "language": "EN",
        "text": "Impact"
      }
    ]
  },
  {
    "key": "txtTourFilters",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل التصفية"
      },
      {
        "language": "EN",
        "text": "Filters"
      }
    ]
  },
  {
    "key": "txtTourFilters_desc",
    "text": "Select criteria from the <b>Filters</b> to narrow your analysis.<br><br>Note: The number of respondents must be at least 3 to view the analysis of each criterion.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر معيار من عوامل <b>التصفية</b> لحصر نطاق تحليلك.<br><br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل معيار مختارة."
      },
      {
        "language": "EN",
        "text": "Select criteria from the <b>Filters</b> to narrow your analysis.<br><br>Note: The number of respondents must be at least 3 to view the analysis of each criterion."
      }
    ]
  },
  {
    "key": "txtAiExecutiveSummary_tour_desc",
    "text": "Get an AI-generated summary of your organization's readiness across the five <b>READY</b> pillars. Each pillar is flagged as a strength or a gap, with Top Strategic Priorities ranking your next best actions.<br><br>Note: You can regenerate the summary anytime for a fresh read.",
    "translations": [
      {
        "language": "AR",
        "text": "احصل على الملخص التنفيذي للذكاء الاصطناعي لجاهزية مؤسستك عبر ركائز <b>READY</b> الخمس. يتم تصنيف كل ركيزة كنقطة قوة أو فجوة، مع تصنيف أهم الأولويات الاستراتيجية لأفضل خطواتك التالية.<br><br>ملاحظة: يمكنك إعادة إنشاء الملخص في أي وقت للحصول على قراءة محدثة."
      },
      {
        "language": "EN",
        "text": "Get an AI-generated summary of your organization's readiness across the five <b>READY</b> pillars. Each pillar is flagged as a strength or a gap, with Top Strategic Priorities ranking your next best actions.<br><br>Note: You can regenerate the summary anytime for a fresh read."
      }
    ]
  },
  {
    "key": "txtAiReadinessScore_tour_desc",
    "text": "View the organization's overall <b>AI Readiness Score</b> at a glance, as well as the breakdown across the five READY pillars.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على <b>درجة جاهزية الذكاء الاصطناعي</b>، إضافةً إلى توزيعها عبر ركائز READY الخمس."
      },
      {
        "language": "EN",
        "text": "View the organization's overall <b>AI Readiness Score</b> at a glance, as well as the breakdown across the five READY pillars."
      }
    ]
  },
  {
    "key": "txtAiReadinessIndex_tour_desc",
    "text": "View the percentage of participants in each readiness band: Not Ready, Planning, Developing, Ready.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على نسبة المشاركين ضمن كل فئة من فئات الجاهزية: غير جاهز، قيد التخطيط، قيد التطوير، جاهز."
      },
      {
        "language": "EN",
        "text": "View the percentage of participants in each readiness band: Not Ready, Planning, Developing, Ready."
      }
    ]
  },
  {
    "key": "txtAiReadinessIndexByPillar_tour_desc",
    "text": "View the breakdown for each individual READY pillar using the Breakout dropdown to switch between pillars.",
    "translations": [
      {
        "language": "AR",
        "text": "اطّلع على التوزيع الخاص بكل ركيزة من ركائز READY باستخدام القائمة المنسدلة \"تفصيل حسب\" للتنقل بين الركائز."
      },
      {
        "language": "EN",
        "text": "View the breakdown for each individual READY pillar using the Breakout dropdown to switch between pillars."
      }
    ]
  },
  {
    "key": "txt_FilterbyStatus",
    "text": "Filter by Status",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية حسب الحالة"
      },
      {
        "language": "EN",
        "text": "Filter by Status"
      }
    ]
  },
  {
    "key": "txt_FilterbyStatus_desc",
    "text": "Click here to filter the respondents by completed, in-progress, not started, or inactive.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتصفية المستجيب حسب المكتمل، أو قيد الإنجاز، لم يبدأ، أو غير فعال."
      },
      {
        "language": "EN",
        "text": "Click here to filter the respondents by completed, in-progress, not started, or inactive."
      }
    ]
  },
  {
    "key": "txt_Orchart_440",
    "text": "Org Chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Org Chart"
      }
    ]
  },
  {
    "key": "txt_Orchart_440_desc",
    "text": "In the \"Org chart\" page, you can explore your organization's structure — whether by function or position — and see how each level is performing at a glance, making it easier to spot strengths and areas for growth.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"الهيكل التنظيمي\"، يمكنك استعراض هيكل مؤسستك — سواء التنظيمي أو الوظيفي — والاطّلاع على أداء كل مستوى بنظرة واحدة، مما يسهّل عليك تحديد نقاط القوة وفرص التطوير."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "In the \"Org chart\" page, you can explore your organization's structure — whether by function or position — and see how each level is performing at a glance, making it easier to spot strengths and areas for growth."
      }
    ]
  },
  {
    "key": "txt_Dimension_880",
    "text": "Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "الركائز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Pillars"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Pillars",
    "translations": [
      {
        "language": "AR",
        "text": "الركائز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Pillars"
      }
    ]
  },
  {
    "key": "txt_Workplace_690",
    "text": "AI Readiness Scores",
    "translations": [
      {
        "language": "AR",
        "text": "درجات جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "AI Readiness Scores"
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "AI Readiness Score"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Score"
      }
    ]
  },
  {
    "key": "txt_AllDimens_652",
    "text": "All Pillars",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "All Pillars"
      }
    ]
  },
  {
    "key": "txt_Dimension_544",
    "text": "Pillar: <span class=\"font-medium text-zen-primaryDark\">{{0}}</span>",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Pillar: <span class=\"font-medium text-zen-primaryDark\">{{0}}</span>"
      }
    ]
  },
  {
    "key": "txt_OverallEm_279",
    "text": "Overall AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall AI Readiness Score"
      }
    ]
  },
  {
    "key": "ORG_POS_MeanScore",
    "text": "Team Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الفريق"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Team Readiness Score"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Overall Score"
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "ID"
      }
    ]
  },
  {
    "key": "CompanyMeanScore",
    "text": "Company Average",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الشركة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Company Average"
      }
    ]
  },
  {
    "key": "ResponseRate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Response Rate"
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION_P",
    "text": "Go beyond the overall scores, select a specific AI Readiness pillar to see how your superior teams are scoring on each area of AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج جاهزية الذكاء الاصطناعي الكلية واختر ركيزة محددة لمعرفة درجات فرق المدراء في كل ركيزة من ركائز جاهزية الذكاء الاصطناعي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION_P",
    "text": "Sort superior team scores in ascending or descending order to quickly identify your top and lowest AI Readiness superiors.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج فرق المدراء تصاعديًا أو تنازليًا لتحديد المدراء الأعلى والأقل جاهزية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Sort superior team scores in ascending or descending order to quickly identify your top and lowest AI Readiness superiors."
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION_P",
    "text": "Compare scores across multiple superiors and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن النتائج بين المدراء والفرق التابعة لهم واطّلع على أدائهم مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION_P",
    "text": "See how your superior teams stack up against each other. Use Multi-Compare to compare AI Readiness scores across multiple superiors at once, or Peer-to-Peer to put two superiors' side by side by checking the boxes, making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت درجات جاهزية الذكاء الاصطناعي بين فرق المدراء المختلفة. استخدم المقارنة المتعددة لمقارنة درجات جاهزية الذكاء الاصطناعي بين المدراء دفعة واحدة، أو المقارنة بين مديرين لوضع المدراء وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_2",
    "text": "Switch to the positional view to explore the org chart based on superiors and their teams, helping you understand AI Readiness dynamics at the team level and identify where leadership is making an impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى العرض حسب الهيكل الوظيفي لعرض أداء كل مدير مباشر والفريق التابع له. يمكنك من خلاله فهم مستويات جاهزية الذكاء الاصطناعي على مستوى الفرق، وتحديد مدى تأثير القيادة على النتائج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_DESCRIPTION",
    "text": "Download the multi-compare report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة المتعددة لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_TITLE",
    "text": "Multi-Compare Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION",
    "text": "Go beyond the overall scores, select a specific AI Readiness pillar to see how your entities are scoring on each area of AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج جاهزية الذكاء الاصطناعي الكلية واختر ركيزة محددة لمعرفة درجات الوحدات في كل ركيزة من ركائز جاهزية الذكاء الاصطناعي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_TITLE",
    "text": "Pillars Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الركائز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Pillars Selection"
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION",
    "text": "Sort entity scores in ascending or descending order to quickly identify your top and lowest AI Readiness entities.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج الوحدات تصاعديًا أو تنازليًا لتحديد الوحدات الأعلى والأقل جاهزية."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Sort entity scores in ascending or descending order to quickly identify your top and lowest AI Readiness entities."
      }
    ]
  },
  {
    "key": "ORG_T_17_TITLE",
    "text": "Sorting",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION",
    "text": "Compare scores across multiple entities and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات جاهزية الذكاء الاصطناعي عبر عدة وحدات واطّلع على أدائها مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_TITLE",
    "text": "Multi Compare",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين وحدتين لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format."
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE",
    "text": "Peer-to-Peer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين الوحدتين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Peer-to-Peer Report"
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION",
    "text": "Use the dropdown to switch entities and explore different entity comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير الوحدات واستعراض مقارنات مختلفة بين الوحدات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Use the dropdown to switch entities and explore different entity comparisons."
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE",
    "text": "Change Entities",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير الوحدات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Change Entities"
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION",
    "text": "Easily spot differences in AI Readiness scores and key pillars between entities — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات جاهزية الذكاء الاصطناعي والركائز الرئيسية بين الوحدات بسهولة — معروضة جنبًا إلى جنب."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Easily spot differences in AI Readiness scores and key pillars between entities — all displayed side by side."
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين وحدتين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Peer-to-Peer Comparison"
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION",
    "text": "See how your entities stack up against each other. Use Multi-Compare to compare AI Readiness scores across multiple entities at once, or Peer- to-Peer to put two entities side by side by checking the boxes — making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت الوحدات فيما بينها. استخدم المقارنة المتعددة لمقارنة درجات جاهزية الذكاء الاصطناعي بين عدة وحدات دفعة واحدة، أو المقارنة بين وحدتين لوضع وحدتين وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_TITLE",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_10_DESCRIPTION",
    "text": "Customize your view by changing the layout, displaying key analysis, or selecting a specific pillar to explore deeper insights. Note: A maximum of 3 options can be selected",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير طريقة عرض النتائج من خلال تعديل التخطيط، أو إظهار أبرز التحليلات، أو اختيار ركيزة محددة للتعمّق في التحليلات. ملاحظة: يمكن اختيار 3 خيارات كحد أقصى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_11_TITLE",
    "text": "Entity Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الوحدات"
      }
    ]
  },
  {
    "key": "ORG_T_11_DESCRIPTION",
    "text": "Click on any entity to dive into its detailed AI Readiness insights — view its overall scores, see how it compares to the organization’s average, and track historical trends to understand how AI Readiness has evolved.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أي وحدة للاطّلاع على تفاصيل جاهزية الذكاء الاصطناعي الخاصة بها، بما في ذلك درجة جاهزية الذكاء الاصطناعي الكلية، ومقارنتها بمتوسط المؤسسة وتتبع تطورها."
      }
    ]
  },
  {
    "key": "ORG_T_11_TITLE_P",
    "text": "Superior Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المدراء"
      }
    ]
  },
  {
    "key": "ORG_T_11_DESCRIPTION_P",
    "text": "Click on any superior to dive into its detailed team AI Readiness insights — view its overall scores, see how it compares to the organization’s average, and track historical trends to understand how AI Readiness has evolved.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أي مدير للاطّلاع على تفاصيل جاهزية الذكاء الاصطناعي الخاصة بالفريق التابع له، بما في ذلك درجة جاهزية الذكاء الاصطناعي الكلية، ومقارنتها بمتوسط المؤسسة، وتتبّع تطوّرها."
      }
    ]
  },
  {
    "key": "ORG_T_10_TITLE",
    "text": "Customize View",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_1",
    "text": "View your org chart by function to see how your entities are structured and how AI Readiness scores are distributed across them, giving you a clear picture of performance at every level of your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض الهيكل التنظيمي حسب الإدارات لترى كيف يتم تنظيم الوحدات داخل مؤسستك وكيف تتوزع درجات جاهزية الذكاء الاصطناعي بينها، مما يمنحك صورة واضحة عن الأداء على مختلف مستويات المؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_1",
    "text": "Functional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_2",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_DESCRIPTION",
    "text": "Click here to re-center the org chart and bring it back to the default view.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أيقونة التمركز لإعادة الهيكل التنظيمي فورًا إلى منتصف الشاشة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_TITLE",
    "text": "Center",
    "translations": [
      {
        "language": "AR",
        "text": "التمركز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_DESCRIPTION",
    "text": "Switch to full-screen mode for a wider, more immersive view of your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى وضع ملء الشاشة للحصول على عرض أوسع وأشمل للهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_TITLE",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "ملء الشاشة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_DESCRIPTION",
    "text": "Want to see the full picture? Expand the org chart to reveal all levels and details across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد رؤية الصورة الكاملة؟ قم بتوسيع الهيكل التنظيمي لاستعراض جميع المستويات والتفاصيل في مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_TITLE",
    "text": "Expand",
    "translations": [
      {
        "language": "AR",
        "text": "توسيع"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_DESCRIPTION",
    "text": "Collapse the entire org chart at once to reset the view and start fresh from the top level.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بطي الهيكل التنظيمي بالكامل لإعادة ضبط العرض والبدء من المستوى الأعلى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_TITLE",
    "text": "Collapse",
    "translations": [
      {
        "language": "AR",
        "text": "طيّ"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_DESCRIPTION",
    "text": "Zoom out to see the bigger picture of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتصغير العرض لرؤية الصورة الأشمل لهيكل مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_TITLE",
    "text": "Zoom Out",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_DESCRIPTION",
    "text": "Zoom in to take a closer look at specific areas of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتكبير العرض لإلقاء نظرة أقرب على مناطق محددة في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_TITLE",
    "text": "Zoom In",
    "translations": [
      {
        "language": "AR",
        "text": "تكبير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_2_DESCRIPTION",
    "text": "Quickly find what you need using the search bar — search by entity or superior and navigate directly to the right spot in your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم شريط البحث للوصول السريع إلى ما تحتاجه — ابحث حسب الوحدة أو المسؤول المباشر وانتقل فورًا إلى موقعه في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_2_TITLE",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "البحث"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "EN",
        "text": "Survey"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Survey Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون للاستبيان"
      },
      {
        "language": "EN",
        "text": "Survey Respondents List"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Planning"
      }
    ]
  },
  {
    "key": "txt_not_started",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يبدأ"
      },
      {
        "language": "EN",
        "text": "Not Started"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      },
      {
        "language": "EN",
        "text": "In Progress"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذفه"
      },
      {
        "language": "EN",
        "text": "Deleted"
      }
    ]
  },
  {
    "key": "txtAiReadinessComparison",
    "text": "AI Readiness Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Comparison"
      }
    ]
  },
  {
    "key": "txtAiReadinessSurveyPreview",
    "text": "AI Readiness Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Survey Preview"
      }
    ]
  },
  {
    "key": "txtWorkplaceAiReadinessScore",
    "text": "AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي مكان العمل"
      },
      {
        "language": "EN",
        "text": "AI Readiness Score"
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Planning"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost AI Readiness.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز جاهزية الذكاء الاصطناعي."
      },
      {
        "language": "EN",
        "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost AI Readiness."
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐” أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      },
      {
        "language": "EN",
        "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you!"
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      },
      {
        "language": "EN",
        "text": "Translation"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      },
      {
        "language": "EN",
        "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level."
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      },
      {
        "language": "EN",
        "text": "Scope"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      },
      {
        "language": "EN",
        "text": "Choose the start and end dates for your action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      },
      {
        "language": "EN",
        "text": "Duration"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once everything looks good, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Select key pillars or topics based on low scores and employee feedback to drive targeted improvements.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الركائز أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      },
      {
        "language": "EN",
        "text": "Select key pillars or topics based on low scores and employee feedback to drive targeted improvements.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      },
      {
        "language": "EN",
        "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      },
      {
        "language": "EN",
        "text": "Topic Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      },
      {
        "language": "EN",
        "text": "Easily navigate between selected focus areas to select your initiatives!"
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      },
      {
        "language": "EN",
        "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited."
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      },
      {
        "language": "EN",
        "text": "Initiatives"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      },
      {
        "language": "EN",
        "text": "You can also add initiatives manually."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      },
      {
        "language": "EN",
        "text": "Custom Initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      },
      {
        "language": "EN",
        "text": "Fill in your \"Initiative Title\""
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "Title"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      },
      {
        "language": "EN",
        "text": "Fill in your \" Initiative Description\""
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      },
      {
        "language": "EN",
        "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Duration"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      },
      {
        "language": "EN",
        "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      },
      {
        "language": "EN",
        "text": "Assign Owner"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      },
      {
        "language": "EN",
        "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!"
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI-Generated Initiatives"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث.\nملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      },
      {
        "language": "EN",
        "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well."
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "EN",
        "text": "Edit"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your initiatives, click “Next” to continue."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      },
      {
        "language": "EN",
        "text": "Easily navigate between selected focus areas to select your tasks!"
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited."
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      },
      {
        "language": "EN",
        "text": "Tasks"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      },
      {
        "language": "EN",
        "text": "Add customized tasks based on your specific needs."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      },
      {
        "language": "EN",
        "text": "Add Task"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      },
      {
        "language": "EN",
        "text": "You can update the task by clicking on the pen icon."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      },
      {
        "language": "EN",
        "text": "Edit Task"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      },
      {
        "language": "EN",
        "text": "You can delete any task by clicking on the delete icon."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      },
      {
        "language": "EN",
        "text": "Delete Task"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      },
      {
        "language": "EN",
        "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!"
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI- Generated Tasks"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      },
      {
        "language": "EN",
        "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      },
      {
        "language": "EN",
        "text": "Assign Owner"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      },
      {
        "language": "EN",
        "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner"
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "EN",
        "text": "Next"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      },
      {
        "language": "EN",
        "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching."
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      },
      {
        "language": "EN",
        "text": "Action Plan Details"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      },
      {
        "language": "EN",
        "text": "Once everything is set, click Launch to make your action plan live."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      },
      {
        "language": "EN",
        "text": "Launch"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      },
      {
        "language": "EN",
        "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      },
      {
        "language": "EN",
        "text": "Action Plan List"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      },
      {
        "language": "EN",
        "text": "Edit or delete the action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      },
      {
        "language": "EN",
        "text": "Edit Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      },
      {
        "language": "EN",
        "text": "To access an action plan, click Open."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      },
      {
        "language": "EN",
        "text": "Accessing Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      },
      {
        "language": "EN",
        "text": "Give your plan a clear, descriptive name to get started."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      },
      {
        "language": "EN",
        "text": "Title"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      },
      {
        "language": "EN",
        "text": "Add a brief description to explain the purpose and focus of your action plan."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "EN",
        "text": "Description"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted. Hint: Minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات. تلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      },
      {
        "language": "EN",
        "text": "Monitor real-time responses and track participation as feedback is submitted. Hint: Minimum of three responses is required to close the survey."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      },
      {
        "language": "EN",
        "text": "Live Analytics"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      },
      {
        "language": "EN",
        "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      },
      {
        "language": "EN",
        "text": "Result View"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      },
      {
        "language": "EN",
        "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "EN",
        "text": "Export"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      },
      {
        "language": "EN",
        "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance."
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      },
      {
        "language": "EN",
        "text": "Tracking"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Pillar.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو الركائز."
      },
      {
        "language": "EN",
        "text": "Here you view the selected Focus Areas, whether Topics or Pillar."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      },
      {
        "language": "EN",
        "text": "Focus Areas"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      },
      {
        "language": "EN",
        "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      },
      {
        "language": "EN",
        "text": "Tasks Management"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      },
      {
        "language": "EN",
        "text": "You can filter initiatives by status: In Progress, Completed, or Expired."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      },
      {
        "language": "EN",
        "text": "Status Filter"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      },
      {
        "language": "EN",
        "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      },
      {
        "language": "EN",
        "text": "Request for Feedback"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      },
      {
        "language": "EN",
        "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      },
      {
        "language": "EN",
        "text": "Respondent Selection"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. Hint: you can add up to three reminders.",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية. تلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      },
      {
        "language": "EN",
        "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. Hint: you can add up to three reminders."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "EN",
        "text": "Time Frame"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      },
      {
        "language": "EN",
        "text": "Customize the email template sent or use the default template generated by Zenithr."
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      },
      {
        "language": "EN",
        "text": "Email Template"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      },
      {
        "language": "EN",
        "text": "Click Send Now to share the invitations with respondents."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      },
      {
        "language": "EN",
        "text": "Send Invite"
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الركيزة"
      },
      {
        "language": "EN",
        "text": "By Pillar"
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For AI Readiness Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لـ استبيان جاهزية الذكاء الاصطناعي:"
      },
      {
        "language": "EN",
        "text": "For AI Readiness Survey:"
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Pillar",
    "translations": [
      {
        "language": "AR",
        "text": "الركيزة"
      },
      {
        "language": "EN",
        "text": "Pillar"
      }
    ]
  },
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Pillar AI Readiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة جاهزية الذكاء الاصطناعي للركيزة"
      },
      {
        "language": "EN",
        "text": "Pillar AI Readiness Score"
      }
    ]
  },
  {
    "key": "txt_PillarSentimentFilter",
    "text": "Pillar Sentiment Filter",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية مشاعر الركائز"
      },
      {
        "language": "EN",
        "text": "Pillar Sentiment Filter"
      }
    ]
  },
  {
    "key": "txt_PillarSentimentFilter_desc",
    "text": "Click on the bar to filter each pillar’s/statement’s comments by sentiment type.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على الشريط لعرض تعليقات كل ركيزة/عبارة حسب نوع المشاعر والآراء."
      },
      {
        "language": "EN",
        "text": "Click on the bar to filter each pillar’s/statement’s comments by sentiment type."
      }
    ]
  },
  {
    "key": "txt_ViewComments_pillar_desc",
    "text": "Click here to expand the comments under each pillar.<br><br> Note: all comments are anonymous!",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التعليقات تحت كل ركيزة. <br><br>ملحوظة: جميع التعليقات مجهولة الهوية!"
      },
      {
        "language": "EN",
        "text": "Click here to expand the comments under each pillar.<br><br> Note: all comments are anonymous!"
      }
    ]
  },
  {
    "key": "txtAiReadinessComparison",
    "text": "AI Readiness Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "EN",
        "text": "AI Readiness Comparison"
      }
    ]
  },
  {
    "key": "txtInDays",
    "text": "(in {{0}} days)",
    "translations": [
      {
        "language": "AR",
        "text": "(خلال {{0}} أيام)"
      },
      {
        "language": "EN",
        "text": "(in {{0}} days)"
      }
    ]
  },
  {
    "key": "txt_Planning&_973",
    "text": "Planning & Action",
    "translations": [
      {
        "language": "AR",
        "text": "التخطيط والعمل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE_P",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين مديرين"
      },
      {
        "language": "EN",
        "text": "Peer-to-Peer Comparison"
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION_P",
    "text": "Easily spot differences in AI Readiness scores and key pillars between superiors — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات جاهزية الذكاء الاصطناعي والركائز الرئيسية بين المدراء والفرق التابعة لهم بسهولة — معروضة جنبًا إلى جنب."
      },
      {
        "language": "EN",
        "text": "Easily spot differences in AI Readiness scores and key pillars between superiors — all displayed side by side."
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE_P",
    "text": "Change Superiors",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير المدراء"
      },
      {
        "language": "EN",
        "text": "Change Superiors"
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION_P",
    "text": "Use the dropdown to switch between superiors and explore different superior teams’ comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير المدراء واستعرض المقارنات بين الفرق التابعة لهم."
      },
      {
        "language": "EN",
        "text": "Use the dropdown to switch between superiors and explore different superior teams’ comparisons."
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE_P",
    "text": "Peer-to-Peer Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين مديرين"
      },
      {
        "language": "EN",
        "text": "Peer-to-Peer Comparison Report"
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION_P",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين مديرين لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "EN",
        "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "Create Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      },
      {
        "language": "EN",
        "text": "Create Action Plan"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      },
      {
        "language": "EN",
        "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      },
      {
        "language": "EN",
        "text": "Filters"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      },
      {
        "language": "EN",
        "text": "Click here to filter and create an action plan for a selected entity or company-wide."
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "PILLAR / IMPACT",
    "translations": [
      {
        "language": "AR",
        "text": "الركيزة / التأثير"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "PILLAR / IMPACT"
      }
    ]
  },
  {
    "key": "txtChooseLanguage",
    "text": "Choose Language",
    "translations": [
      {
        "language": "EN",
        "text": "Choose Language"
      },
      {
        "language": "AR",
        "text": "اختيار اللغة"
      },
      {
        "language": "FR",
        "text": "Choisir la langue"
      },
      {
        "language": "HI",
        "text": "भाषा चुनें"
      },
      {
        "language": "TA",
        "text": "மொழியைத் தேர்ந்தெடுக்கவும்"
      },
      {
        "language": "UR",
        "text": "زبان منتخب کریں"
      },
      {
        "language": "BN",
        "text": "ভাষা নির্বাচন করুন"
      },
      {
        "language": "NL",
        "text": "Kies een taal"
      },
      {
        "language": "ES",
        "text": "Elegir idioma"
      },
      {
        "language": "DE",
        "text": "Sprache wählen"
      },
      {
        "language": "LA",
        "text": "Linguam elige"
      },
      {
        "language": "SI",
        "text": "භාෂාව තෝරන්න"
      },
      {
        "language": "NE",
        "text": "भाषा छान्नुहोस्"
      },
      {
        "language": "ML",
        "text": "ഭാഷ തിരഞ്ഞെടുക്കുക"
      },
      {
        "language": "ID",
        "text": "Pilih bahasa"
      },
      {
        "language": "TR",
        "text": "Dil seçin"
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "EN",
        "text": "Continue"
      },
      {
        "language": "AR",
        "text": "استمر"
      },
      {
        "language": "FR",
        "text": "Continuer"
      },
      {
        "language": "HI",
        "text": "जारी रखें"
      },
      {
        "language": "TA",
        "text": "தொடரவும்"
      },
      {
        "language": "UR",
        "text": "جاری رکھیں"
      },
      {
        "language": "BN",
        "text": "চালিয়ে যান"
      },
      {
        "language": "NL",
        "text": "Doorgaan"
      },
      {
        "language": "ES",
        "text": "Continuar"
      },
      {
        "language": "DE",
        "text": "Weiter"
      },
      {
        "language": "LA",
        "text": "Pergere"
      },
      {
        "language": "SI",
        "text": "ඉදිරියට යන්න"
      },
      {
        "language": "NE",
        "text": "जारी राख्नुहोस्"
      },
      {
        "language": "ML",
        "text": "തുടരുക"
      },
      {
        "language": "ID",
        "text": "Lanjutkan"
      },
      {
        "language": "TR",
        "text": "Devam et"
      }
    ]
  },
  {
    "key": "txt_Analysis&_518",
    "text": "Analysis & insights",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "EN",
        "text": "Analysis & insights"
      }
    ]
  }
]